// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-24T16:58:41.368Z
// Property: Aria Townhomes & Apartments (ID: 6767906449166425)
// Collections: 18 amenities, 15 floorplans (live), 24 photos, 50 POIs, 5 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166425",
  "property_external_id": "kvk0ml9",
  "property_zillow_url": "https://www.zillow.com/apartments/syracuse-ut/aria-townhomes-and-apartments/Cjf6Vp/",
  "property_apartments_url": "https://www.apartments.com/aria-townhomes-apartments-syracuse-ut/kvk0ml9/",
  "property_google_business_url": "https://www.google.com/maps/place/Aria/@41.088376,-112.0513409,893m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87531bdd2c0bf0ed:0x803b2d2c6ae7a7dd!8m2!3d41.088376!4d-112.0513409!16s%2Fg%2F11qb97bcx0!5m1!1e2?entry=ttu&g_ep=EgoyMDI2MDcxMi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "8618002786",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "658ARI",
  "property_status": null,
  "property_slug": "aria-townhomes-&-apartments",
  "property_name": "Aria Townhomes & Apartments",
  "property_website_url": "https://www.liveariaut.com/",
  "property_domain": "https://www.liveariaut.com/",
  "property_address": "1283 West 1700 South",
  "property_full_address": "1283 W 1700 S, Syracuse, UT 84075",
  "property_address_1": "1283 W 1700 S",
  "property_address_2": null,
  "property_address_city": "Syracuse",
  "property_address_state": "UT",
  "property_address_zip_full": null,
  "property_address_zip": "84075",
  "property_address_country": "US",
  "property_address_county": "Davis County",
  "property_neighborhood_address": "Outer Northern Davis County",
  "property_address_latitude": "41.0878474",
  "property_address_longitude": "-112.0517356",
  "property_email": null,
  "property_phone": "(385) 442-9647",
  "property_call_tracking_phone": "866-663-3139",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Aria in Syracuse, UT, where comfort meets style! Choose from spacious one, two, or three-bedroom floor plans, all featuring modern amenities like quartz countertops, stainless steel appliances, and on-site maintenance. Dive into luxury with our swimming pool, fitness center, and hot tub. Find your new home today!",
  "property_long_description": "Welcome to Aria, the premier apartment community in beautiful Syracuse, UT, where modern living meets comfort and convenience! Our thoughtfully designed floor plans offer a variety of options to cater to your lifestyle, featuring spacious one, two, and three-bedroom apartments that come equipped with all the essential amenities you need to feel right at home. With stylish finishes like quartz countertops, stainless steel appliances, and LVT flooring, your new apartment is not only functional but also a reflection of your taste.\n\nEnjoy a wealth of fantastic community amenities designed for relaxation, recreation, and socializing. Dive into our sparkling swimming pool, unwind in the soothing hot tub, or get moving in our fully-equipped fitness center. For those who enjoy friendly competition, our on-site pickleball court is perfect for some fun exercise. Additionally, little ones will love the playground, while residents will appreciate the clubhouse—a great place to gather with neighbors and friends.\n\nAt Aria, convenience is key, which is why we offer online payment options, on-site maintenance, and detached garages for your vehicle. Each apartment features modern comforts like air conditioning, heating, a dishwasher, refrigerator, washer, and dryer to make daily life easier.\n\nDon’t miss your chance to experience life at Aria. Explore our available floor plans and discover why our community is the ideal place to live. Find your new home today—browse our availability or schedule a tour to visit us and see everything Aria has to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f6b9a-8242-7229-bf51-98a57d208918.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and a reflection of the apartment buildings.",
    "public_id": "019f6b9a-8242-7229-bf51-98a57d208918",
    "storage_key": "property/6767906449166425/019f6b9a-8242-7229-bf51-98a57d208918.webp",
    "width": 1920,
    "height": 1281
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166425/019ffc39-020b-71d9-ae3e-c03d550b6a41.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc39-020b-71d9-ae3e-c03d550b6a41",
    "storage_key": "property/6767906449166425/019ffc39-020b-71d9-ae3e-c03d550b6a41.m4v",
    "thumbnail_key": "property/6767906449166425/019ffc39-020b-71d9-ae3e-c03d550b6a41_thumb.webp",
    "size_bytes": 24954591,
    "classification": "Community",
    "title": "Discover Luxury Living: Amenities & Interiors",
    "description": "Explore our community's stunning pool, state-of-the-art gym, playground, and beautifully designed apartment interiors. Experience the best of modern living."
  },
  "property_total_units": "351",
  "property_year_built": "2023",
  "property_year_renovated": null,
  "property_walk_score": "57",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.01139601139602",
  "property_admin_fee": "250",
  "property_application_fee": "65",
  "property_fees_deposit_info": "$300-1 Month's Rent OAC",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "250",
  "property_monthly_pet_rent": "45",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "65",
  "property_pet_restrictions": "Dogs and cats allowed, up to 2 pets per unit. Maximum weight 65 lbs each.",
  "property_pet_policy_description": "Dogs and cats allowed, up to 2 pets per unit. Maximum weight 65 lbs each. Pet deposit: $500 per pet. Monthly pet rent: $40 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://aria.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amcaria",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c9-c67e-707f-b2b2-f78029371f61.webp",
  "property_primary_logo_media": {
    "alt_text": "Aria logo.",
    "public_id": "019d02c9-c67e-707f-b2b2-f78029371f61",
    "storage_key": "property/6767906449166425/019d02c9-c67e-707f-b2b2-f78029371f61.webp",
    "width": 205,
    "height": 100
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c9-b180-768f-a0c5-d62fe288d14f.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c9-b180-768f-a0c5-d62fe288d14f",
    "storage_key": "property/6767906449166425/019d02c9-b180-768f-a0c5-d62fe288d14f.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c9-d971-70ba-bcd0-9a5d346f74d9.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Aria logo",
    "public_id": "019d02c9-d971-70ba-bcd0-9a5d346f74d9",
    "storage_key": "property/6767906449166425/019d02c9-d971-70ba-bcd0-9a5d346f74d9.webp",
    "width": 205,
    "height": 100
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c9-e164-753a-ac03-dec7c1efc103.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Aria logo",
    "public_id": "019d02c9-e164-753a-ac03-dec7c1efc103",
    "storage_key": "property/6767906449166425/019d02c9-e164-753a-ac03-dec7c1efc103.webp",
    "width": 205,
    "height": 100
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "826 - 1875",
  "property_sqft_min": "826",
  "property_sqft_max": "1875",
  "property_price_range": "$1309 - $2669",
  "property_price_min": "1309",
  "property_price_max": "2669",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/AriaApartmentsSyracuse/",
  "property_instagram_url": "https://www.instagram.com/ariaapartmentsandtownhomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ7fALLN0bU4cR3afnaiwtO4A",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Syracuse%2C+UT+84075",
  "property_tiktok_url": "https://www.tiktok.com/@liveariaut/video/7650299444100877599",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Aria",
  "property_home_romance_title": "Embrace Cozy Living in Your Dream Apartment Community",
  "property_home_amenities_blurb": "Welcome to Aria in scenic Syracuse, UT, where modern living meets unmatched comfort. Choose from stylish one, two, or three-bedroom apartments, each featuring elegant quartz countertops, stainless steel appliances, and LVT floors. Enjoy top-tier amenities, from a rejuvenating hot tub to an invigorating fitness center, all designed for your lifestyle.",
  "property_home_floorplans_blurb": "Welcome to Aria in picturesque Syracuse, UT, where your ideal home awaits! Whether you seek a cozy one-bedroom, a spacious two-bedroom, or a family-friendly three-bedroom, our diverse floor plans cater to every lifestyle. Browse our available apartments today and step into your new sanctuary!",
  "property_home_gallery_blurb": "Welcome to Aria in Syracuse, UT, where modern living meets exceptional comfort. Choose from versatile one, two, or three-bedroom floor plans, complete with luxurious quartz countertops and stainless steel appliances. Enjoy fabulous amenities like a heated swimming pool, fitness center, and on-site maintenance. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Nestled in scenic Syracuse, UT, Aria offers spacious one, two, and three-bedroom apartments close to vibrant attractions. Enjoy family outings at Layton Commons Park, and explore cultural treasures like the Hill Aerospace Museum and the Heritage Museum of Layton. Experience modern living blended with local charm just steps from your door!",
  "property_home_reviews_blurb": "At Aria Townhomes and Apartments in Syracuse, UT, our residents rave about the welcoming atmosphere and attentive staff. One resident described it perfectly: \"The management team was readily available and answered questions promptly.\" Experience a vibrant community where kindness and exceptional service create a true sense of home.",
  "property_neighborhood_blurb": "Nestled in the heart of Syracuse, Aria offers easy access to vibrant attractions like the Hill Aerospace Museum and Layton Aquarium & Wildlife. Enjoy the serenity of nearby parks and explore local gems like Weber State University Davis. Experience community living that seamlessly blends relaxation and adventure.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Aria in Syracuse, UT, your ideal home awaits with spacious one, two, and three-bedroom floor plans. Enjoy modern living with amenities like a sparkling swimming pool, inviting hot tub, and state-of-the-art fitness center. Embrace community life with pickleball, a playground, and a stylish clubhouse. Discover comfort today!",
  "property_applynow_blurb": "At Aria in Syracuse, UT, embrace modern living with spacious one, two, and three-bedroom floor plans outfitted with luxurious quartz countertops and stainless steel appliances. Dive into relaxation at the swimming pool or find your fit in our state-of-the-art fitness center. Lease your new home online today!",
  "property_contactus_blurb": "At Aria in Syracuse, UT, our thoughtfully designed floor plans offer a perfect fit for every lifestyle. Whether you're seeking a cozy one-bedroom retreat, a spacious two-bedroom haven, or a family-friendly three-bedroom sanctuary, we have something for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Aria in Syracuse, UT, our versatile floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments—cater to every lifestyle. Curious about amenities or lease options? Dive into our FAQs page for insightful answers and discover how Aria can enhance your living experience. Your questions, our solutions!",
  "property_floorplans_blurb": "At Aria in Syracuse, UT, your ideal space awaits! Choose from thoughtfully designed one, two, and three-bedroom apartments that cater to your lifestyle. Each floor plan blends comfort and style, inviting you to create a home that's uniquely yours. Browse our available apartment homes and find your perfect fit today!",
  "property_gallery_blurb": "At Aria in Syracuse, UT, vibrant living meets modern luxury. Choose from stylish one, two, or three-bedroom apartments featuring quartz countertops, stainless steel appliances, and inviting LVT floors. Enjoy amenities like a refreshing swimming pool, fitness center, and hot tub. Picture yourself living here! Your dream apartment awaits.",
  "property_interactivemap_blurb": "At Aria in Syracuse, UT, your ideal living space awaits! Choose from spacious one, two, or three-bedroom floor plans, each boasting luxurious quartz countertops and stainless steel appliances. Our thriving community provides amenities like a hot tub, fitness center, and pickleball. Use our interactive map to find your new home today!",
  "property_pets_blurb": "At Aria in Syracuse, UT, your furry friends are part of the family! Enjoy spacious apartments designed for both you and pets, with room for two companions weighing up to 65 lbs each. With a welcoming environment and amenities galore, Aria is the perfect place for you and your pets to thrive.",
  "property_referafriend_blurb": "At Aria in Syracuse, UT, your ideal home awaits in our thoughtfully designed one, two, and three-bedroom floor plans. Enjoy vibrant community living with friends by your side—after all, great friends make great neighbors! Refer a friend today and elevate your apartment experience together!",
  "property_residentaccess_blurb": "Welcome to Aria in Syracuse, UT, where comfort meets convenience. Choose from our thoughtfully designed one, two, or three-bedroom floor plans tailored to your lifestyle. Access your resident portal to effortlessly pay rent, schedule maintenance, and stay connected with your community. Your hassle-free living experience starts here!",
  "property_reviews_blurb": "At Aria Townhomes and Apartments in Syracuse, UT, you'll find a vibrant community where kindness meets exceptional service. Residents rave about the attentive management team, especially Jace and Kylee, celebrating the “lovely, spacious” apartments and welcoming atmosphere. Join us and create lasting memories in your new home!",
  "property_created_at": "1759782539182",
  "property_scheduletour_blurb": "At Aria in Syracuse, UT, our thoughtfully designed one, two, and three-bedroom floor plans cater to your every need. Experience modern living in a vibrant community where comfort meets convenience. Curious about life here? Schedule a tour today and hear directly from our satisfied residents!",
  "property_thankyou_blurb": "Thank you for reaching out! At Aria in Syracuse, UT, we offer a harmonious blend of comfort and style with our thoughtfully designed one, two, and three-bedroom floor plans. Your inquiry is important to us, and a team member will be in touch soon to assist you further.",
  "property_virtualtours_blurb": "Step into Aria, where modern living meets serene surroundings in Syracuse, UT. Our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle. Ready to envision your new home? Take a virtual tour of our vibrant community and apartments for rent today!",
  "property_copyright": "2025 All Rights Reserved. Aria",
  "property_seo_title_home": "Aria | Apartments & Townhomes For Rent in Syracuse, UT",
  "property_seo_description_home": "Located in Syracuse, we offer 1, 2, & 3-bedroom pet-friendly apartments & townhomes for rent. Come home to our spectacular apartments & townhomes!",
  "property_seo_title_floorplans": "Floor Plans | 1, 2, & 3 Bedroom Apartments & Townhomes",
  "property_seo_description_floorplans": "Aria offers 1, 2, & 3-bedroom apartments & townhomes with modern comfort in Syracuse, UT. Browse our apartments & townhomes for rent now!",
  "property_seo_title_amenities": "Amenities | Pet-Friendly Syracuse Apartments & Townhomes",
  "property_seo_description_amenities": "Located in Syracuse near Antelope Island, Aria offers 1, 2, & 3-bedroom apartments & townhomes with luxury interiors & resort-style amenities.",
  "property_seo_title_gallery": "Gallery | Apts in Syracuse North of Salt Lake City",
  "property_seo_description_gallery": "View your pet-friendly apartments & townhomes in Syracuse, UT, through our photos. Explore floor plan interiors, amenities, & more north of Salt Lake City!",
  "property_seo_title_virtualtours": "Virtual Tour | Syracuse Apartments & Townhomes For Rent",
  "property_seo_description_virtualtours": "Discover your new home at Aria! Take a virtual tour of our floor plans, amenities, & more. Start your tour now in Syracuse, UT!",
  "property_seo_title_interactivemap": "Interactive Map | Apartments & Townhomes in Syracuse, UT",
  "property_seo_description_interactivemap": "Explore the interactive map of Aria apartments and townhomes in Syracuse, UT, to see available units and find your next home.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments & Townhomes Near Antelope Island",
  "property_seo_description_neighborhood": "Aria is located in Syracuse, UT, near Antelope Island & north of Salt Lake City. Come in for a tour of our apartments & townhomes!",
  "property_seo_title_contact": "Contact Us | Syracuse Apartments & Townhomes For Rent",
  "property_seo_description_contact": "Have questions about our Syracuse apartments & townhomes for rent or want to schedule a tour? Our amazing leasing team is ready to help! Contact us today!",
  "property_seo_title_faqs": "FAQs | Apartments in Syracuse, UT",
  "property_seo_description_faqs": "Find answers to your questions about Aria in Syracuse, UT. From amenities to floor plans, our FAQs provide insight into your future home.",
  "property_seo_title_reviews": "Reviews | Apartments & Townhomes in Syracuse, UT",
  "property_seo_description_reviews": "Explore feedback from residents of Aria! Learn firsthand experiences & gain insights into our vibrant community in Syracuse, UT.",
  "property_seo_title_applynow": "Apply Now | 1, 2, & 3 Bedroom Apartments & Townhomes",
  "property_seo_description_applynow": "Apply online for our 1, 2, and 3-bedroom apartments & townhomes for rent in Syracuse, UT. Complete the application today!",
  "property_seo_title_residentaccess": "Resident Access | Syracuse Apartments & Townhomes for Rent",
  "property_seo_description_residentaccess": "With convenient 24/7 access, the resident portal makes it easy for you to request maintenance service & pay your rent online. Log in to get started.",
  "property_seo_title_referafriend": "Refer a Friend | Apartments & Townhomes in Syracuse, UT",
  "property_seo_description_referafriend": "Refer a friend to Aria & both of you can enjoy fantastic perks. Spread the word!",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments & Townhomes in Syracuse, UT",
  "property_seo_description_scheduletour": "Ready to explore Aria firsthand? Book a tour & uncover our amenities & 1, 2, & 3-bedroom apartments & townhomes for rent in Syracuse, UT!",
  "property_seo_title_privacy": "Privacy Policy | Aria",
  "property_seo_description_privacy": "At Aria in Syracuse, UT, your privacy matters. Learn how we protect your information and maintain a safe, welcoming community. View our privacy policy today.",
  "property_seo_title_accessibility": "Website Accessibility | Aria",
  "property_seo_description_accessibility": "Experience digital inclusion at Aria in Syracuse, UT. Our accessibility statement ensures everyone can enjoy our vibrant community and its amenities.",
  "property_seo_title_sitemap": "Sitemap | Aria",
  "property_seo_description_sitemap": "Navigate your way through Aria in Syracuse, UT. Check out our sitemap for easy access to amenities, floor plans, and community features tailored just for you!",
  "property_seo_title_thankyou": "Thank You | Apartments & Townhomes for Rent in Syracuse, UT",
  "property_seo_description_thankyou": "Thank you for your interest in Aria. We will process your request & get back to you shortly!",
  "property_seo_title_pets": "Pet Policy | Pet-Friendly Apartments in Syracuse, UT",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1786643026018",
  "amenities": [
    {
      "id": "custom_98b56345-870f-4e9d-930d-40d8acd6dc9d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7cd22ddb-c088-4538-9f46-de5768732d76",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "Pool Table",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_172b62ab-aca5-4b9c-9563-f2eedd8fd63d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "Pickleball Court",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_5184dc5a-ad36-4f9c-8356-9ec60f35077d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_c5f30b7e-b54a-4d4e-a93e-0a46f8b8a56b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_b1bc5dd1-2d32-43e9-a66b-8c5e1219f672",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "All Year Round Pool and Hot Tub",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_20266f7a-e209-48da-93c8-fe94199be923",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_2406faf4-1639-43d6-bc73-8c462518464d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "Washer/Dryer Included",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_82e99756-46a3-44b0-88d3-7a16b4664c47",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_39339b91-9aef-4614-a017-0411f30bcb24",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning & Heat",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_62cf6816-24fb-4d9f-bcbf-38052e237103",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_aa5c88bb-2618-49dc-bf1a-2c4a90bd6528",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "Fully Equipped Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f4ff2888-f41c-4f48-bb92-e0e8119e642a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_5aec02ba-9f69-475b-9d0f-50c757317e14",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "Open Floorplans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_39b0dcac-0db8-4623-a01b-41cd902de1b9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_afdc9322-fc2c-4085-8d10-10f9f936682f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "BBQ Grills",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_6cab62ba-071e-4944-b55c-d0dcf0dc2e72",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_6cf533ee-eb29-49ae-9e24-5938f7391ba9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Island",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_03a2d363-01e0-45ce-b09c-af69b940fb72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/01a01715-ef15-71fc-a3e9-43ab4c89ec3b.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern residential community with townhomes and single-family houses, set against a backdrop of mountains at sunset at Aria in Syracuse, UT.",
        "public_id": "01a01715-ef15-71fc-a3e9-43ab4c89ec3b",
        "storage_key": "property/6767906449166425/01a01715-ef15-71fc-a3e9-43ab4c89ec3b.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Discover our vibrant community featuring beautiful townhomes and single-family residences, nestled against a stunning mountain range. Experience modern living at its finest.",
      "link": "",
      "alt_text": "Aerial view of a modern residential community with townhomes and single-family houses, set against a backdrop of mountains at sunset at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a62ed8a-9f24-4e9b-a02a-f6426aa1c160",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/01a01715-c4c9-7138-97f4-a1dd1f48703c.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with balconies and mountain backdrop at sunset at Aria in Syracuse, UT.",
        "public_id": "01a01715-c4c9-7138-97f4-a1dd1f48703c",
        "storage_key": "property/6767906449166425/01a01715-c4c9-7138-97f4-a1dd1f48703c.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Expansive exterior view of a modern apartment complex featuring white siding, stone accents, and balconies, set against a stunning mountain landscape during twilight.",
      "link": "",
      "alt_text": "Modern apartment building exterior with balconies and mountain backdrop at sunset at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4150048f-e985-4375-bc7d-1b4e3089f7d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/01a01715-c78a-729f-ae42-8cc240c72aed.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with a pool table, seating areas, and a coffee bar at Aria in Syracuse, UT.",
        "public_id": "01a01715-c78a-729f-ae42-8cc240c72aed",
        "storage_key": "property/6767906449166425/01a01715-c78a-729f-ae42-8cc240c72aed.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy leisure time in our community lounge, featuring a pool table, comfortable seating, and a convenient coffee bar. Perfect for relaxing or socializing.",
      "link": "",
      "alt_text": "Spacious community lounge with a pool table, seating areas, and a coffee bar at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_053406ea-66c8-469a-8b70-b91badb61cfa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f6699-e38e-71ff-aa84-040adbbe38c8.webp",
      "image_media": {
        "alt_text": "Bar seating area and kitchen in community lounge at Aria in Syracuse, UT.",
        "public_id": "019f6699-e38e-71ff-aa84-040adbbe38c8",
        "storage_key": "property/6767906449166425/019f6699-e38e-71ff-aa84-040adbbe38c8.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy a coffee or relax with friends in the community lounge, featuring a well-equipped kitchen and comfortable seating.",
      "link": "",
      "alt_text": "Bar seating area and kitchen in community lounge at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f041174d-1cf3-4aec-9735-4f3a04531bc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f6699-e475-744d-80e8-1e5f851d3e66.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with a fireplace, comfortable seating, and large windows at Aria in Syracuse, UT.",
        "public_id": "019f6699-e475-744d-80e8-1e5f851d3e66",
        "storage_key": "property/6767906449166425/019f6699-e475-744d-80e8-1e5f851d3e66.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully designed community lounge, featuring a cozy fireplace and ample seating for socializing or quiet reflection.",
      "link": "",
      "alt_text": "Stylish lounge area with a fireplace, comfortable seating, and large windows at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_43647a67-15e5-47e5-af5a-574127c38e64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f6699-e3d7-77af-8bcb-5fea2c5e9845.webp",
      "image_media": {
        "alt_text": "A modern communal lounge area with plush blue beanbag chairs and a large TV mounted on a white shiplap wall at Aria in Syracuse, UT.",
        "public_id": "019f6699-e3d7-77af-8bcb-5fea2c5e9845",
        "storage_key": "property/6767906449166425/019f6699-e3d7-77af-8bcb-5fea2c5e9845.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish communal lounge, featuring comfortable seating, a large screen TV, and a cozy fireplace.",
      "link": "",
      "alt_text": "A modern communal lounge area with plush blue beanbag chairs and a large TV mounted on a white shiplap wall at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5fa95eb2-1aa7-4465-b0b8-675a4981b0e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/01a01715-ca45-7539-99f9-7aa2d74e6bc9.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines, weight racks, and a scenic mountain mural at Aria in Syracuse, UT.",
        "public_id": "01a01715-ca45-7539-99f9-7aa2d74e6bc9",
        "storage_key": "property/6767906449166425/01a01715-ca45-7539-99f9-7aa2d74e6bc9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of cardio equipment, free weights, and a stunning mountain mural to inspire your workouts.",
      "link": "",
      "alt_text": "Gym with cardio machines, weight racks, and a scenic mountain mural at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_168381d9-1feb-4a49-bf6d-09e6ecab06a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f6699-f15c-7637-9e1f-65cf75358bf2.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, weight machines, and free weights at Aria in Syracuse, UT.",
        "public_id": "019f6699-f15c-7637-9e1f-65cf75358bf2",
        "storage_key": "property/6767906449166425/019f6699-f15c-7637-9e1f-65cf75358bf2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, weight machines, and free weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, weight machines, and free weights at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_06860c01-43f8-489e-8393-d8c4d9e374bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f7257-fb36-741a-812e-7aeb6b490452.webp",
      "image_media": {
        "alt_text": "Well-equipped fitness center with cardio machines, free weights, and a scenic mural at Aria in Syracuse, UT.",
        "public_id": "019f7257-fb36-741a-812e-7aeb6b490452",
        "storage_key": "property/6767906449166425/019f7257-fb36-741a-812e-7aeb6b490452.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a wide array of cardio equipment, weight machines, and free weights. The inspiring mural adds a unique touch to your workout experience.",
      "link": "",
      "alt_text": "Well-equipped fitness center with cardio machines, free weights, and a scenic mural at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e7b2f748-6b78-4543-ad8a-b1a8f4eaf718",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/01a01715-c849-74df-a2c0-6a0667fb0d5a.webp",
      "image_media": {
        "alt_text": "Modern apartment building with a resort-style pool and lounge chairs at Aria in Syracuse, UT.",
        "public_id": "01a01715-c849-74df-a2c0-6a0667fb0d5a",
        "storage_key": "property/6767906449166425/01a01715-c849-74df-a2c0-6a0667fb0d5a.webp",
        "width": 3072,
        "height": 1719
      },
      "title": "Community",
      "description": "Enjoy luxury living with our resort-style pool and ample outdoor seating. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Modern apartment building with a resort-style pool and lounge chairs at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2d4ecade-ad73-4f98-8592-9ad118f9436e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/01a01715-cf59-7419-9a88-1ac9e07762aa.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a modern apartment building at sunset.",
        "public_id": "01a01715-cf59-7419-9a88-1ac9e07762aa",
        "storage_key": "property/6767906449166425/01a01715-cf59-7419-9a88-1ac9e07762aa.webp",
        "width": 3072,
        "height": 2038
      },
      "title": "Community",
      "description": "Relax by the sparkling pool or soak up the sun on our comfortable lounge chairs. Enjoy stunning mountain views from our resort-style pool area.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a modern apartment building at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f860d745-5189-4561-acfe-ee9b6933277e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/01a01715-c7e8-73e8-8628-8eecfc875363.webp",
      "image_media": {
        "alt_text": "Community pool and hot tub area with lounge chairs and playground at Aria in Syracuse, UT.",
        "public_id": "01a01715-c7e8-73e8-8628-8eecfc875363",
        "storage_key": "property/6767906449166425/01a01715-c7e8-73e8-8628-8eecfc875363.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling community pool and soothing hot tub. Lounge chairs and a fun playground make this the perfect spot for family and friends.",
      "link": "",
      "alt_text": "Community pool and hot tub area with lounge chairs and playground at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8ecbe8e6-e1f2-4bb8-b40d-a80c4d9ea897",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/01a01715-dd40-75de-a7fd-a30ccc5330a5.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures in front of apartment buildings at Aria in Syracuse, UT.",
        "public_id": "01a01715-dd40-75de-a7fd-a30ccc5330a5",
        "storage_key": "property/6767906449166425/01a01715-dd40-75de-a7fd-a30ccc5330a5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring modern slides and climbing structures perfect for all ages. Located conveniently near apartment buildings and amenities.",
      "link": "",
      "alt_text": "Playground with slides and climbing structures in front of apartment buildings at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ad8f4502-88e9-4da9-b668-8b93a2f7d5ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/01a01715-e282-7109-af1c-c56b9815e508.webp",
      "image_media": {
        "alt_text": "Outdoor court with pickleball lines and a playground at Aria in Syracuse, UT.",
        "public_id": "01a01715-e282-7109-af1c-c56b9815e508",
        "storage_key": "property/6767906449166425/01a01715-e282-7109-af1c-c56b9815e508.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with our pickleball court and playground, perfect for active lifestyles.",
      "link": "",
      "alt_text": "Outdoor court with pickleball lines and a playground at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_033e9e33-694b-4c9a-9ed0-354dab07e622",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/01a01715-e78b-7749-8eca-6b439f829a90.webp",
      "image_media": {
        "alt_text": "Exterior view of townhouses and apartment buildings with mountains in the background at Aria in Syracuse, UT.",
        "public_id": "01a01715-e78b-7749-8eca-6b439f829a90",
        "storage_key": "property/6767906449166425/01a01715-e78b-7749-8eca-6b439f829a90.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "A picturesque view of modern townhouses and apartment buildings set against a backdrop of majestic mountains at sunset, showcasing the community's attractive exterior.",
      "link": "",
      "alt_text": "Exterior view of townhouses and apartment buildings with mountains in the background at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bd8cb504-2df7-47af-ae8b-ac3ae13269d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/01a01715-e732-7063-b66c-db3221dc1ba1.webp",
      "image_media": {
        "alt_text": "Luxer One package lockers with numbered compartments and a touchscreen interface.",
        "public_id": "01a01715-e732-7063-b66c-db3221dc1ba1",
        "storage_key": "property/6767906449166425/01a01715-e732-7063-b66c-db3221dc1ba1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure and convenient Luxer One package lockers available for residents to receive deliveries at any time.",
      "link": "",
      "alt_text": "Luxer One package lockers with numbered compartments and a touchscreen interface.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_72f45dd5-22b0-4c46-a6df-fd23843ee0b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/01a01715-c879-76ab-b941-d5e3e8d80a69.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and a large island with bar stools at Aria in Syracuse, UT.",
        "public_id": "01a01715-c879-76ab-b941-d5e3e8d80a69",
        "storage_key": "property/6767906449166425/01a01715-c879-76ab-b941-d5e3e8d80a69.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover this beautifully appointed kitchen, perfect for cooking and entertaining. Features stainless steel appliances, ample cabinet space, and a stylish island.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and a large island with bar stools at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2480e544-2552-43bc-861a-bf3b8d9c61e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f669a-0256-76bf-bb31-5425007855e7.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and subway tile backsplash at Aria in Syracuse, UT.",
        "public_id": "019f669a-0256-76bf-bb31-5425007855e7",
        "storage_key": "property/6767906449166425/019f669a-0256-76bf-bb31-5425007855e7.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this sleek, modern kitchen featuring white cabinetry, a subway tile backsplash, and stainless steel appliances. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern white kitchen with stainless steel appliances and subway tile backsplash at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1bd4c73f-6318-4611-a7d3-0c3bf506ac63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f669a-01f6-75ed-8d9a-55064b452b90.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and subway tile backsplash.",
        "public_id": "019f669a-01f6-75ed-8d9a-55064b452b90",
        "storage_key": "property/6767906449166425/019f669a-01f6-75ed-8d9a-55064b452b90.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A sleek and modern kitchen featuring white shaker cabinets, a subway tile backsplash, stainless steel appliances including a refrigerator with an ice maker, a dishwasher, and a range.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and subway tile backsplash.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_783ab466-23e6-4af4-8b0a-b27c32eb3968",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/01a01715-d093-779a-8c02-faf543caf9df.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with sleek white cabinets and stainless steel appliances at Aria in Syracuse, UT.",
        "public_id": "01a01715-d093-779a-8c02-faf543caf9df",
        "storage_key": "property/6767906449166425/01a01715-d093-779a-8c02-faf543caf9df.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed apartment, featuring an open-concept living and kitchen area perfect for entertaining.",
      "link": "",
      "alt_text": "Modern living room and kitchen with sleek white cabinets and stainless steel appliances at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7401bba1-3be5-499d-93b2-024562b6a837",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f669a-0c64-73d9-a6ab-5e9f9d01fb39.webp",
      "image_media": {
        "alt_text": "Modern living room with a blue armchair, a beige sofa, and a coffee table at Aria in Syracuse, UT.",
        "public_id": "019f669a-0c64-73d9-a6ab-5e9f9d01fb39",
        "storage_key": "property/6767906449166425/019f669a-0c64-73d9-a6ab-5e9f9d01fb39.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Relax and unwind in this stylish living area, perfect for entertaining or quiet evenings.",
      "link": "",
      "alt_text": "Modern living room with a blue armchair, a beige sofa, and a coffee table at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_921608b5-9150-4073-a588-c1294020f1e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f669a-07e7-7385-8ed9-952d9e116002.webp",
      "image_media": {
        "alt_text": "Living room with modern furniture, artwork, and natural light at Aria in Syracuse, UT.",
        "public_id": "019f669a-07e7-7385-8ed9-952d9e116002",
        "storage_key": "property/6767906449166425/019f669a-07e7-7385-8ed9-952d9e116002.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "A beautifully furnished living room featuring a plush sofa, a stylish armchair, and a contemporary coffee table, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with modern furniture, artwork, and natural light at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_db9bec69-177e-4cb8-b36c-7b034a86fb7b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/01a01715-c9e2-763f-a789-873d5c58bd86.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a king-size bed, large windows, and abstract art at Aria in Syracuse, UT.",
        "public_id": "01a01715-c9e2-763f-a789-873d5c58bd86",
        "storage_key": "property/6767906449166425/01a01715-c9e2-763f-a789-873d5c58bd86.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and beautifully appointed bedroom featuring a comfortable king-size bed, ample natural light from large windows, and stylish decor.",
      "link": "",
      "alt_text": "Modern bedroom with a king-size bed, large windows, and abstract art at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a36a5947-ea4b-453d-b3b0-ff31391cc10f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/01a01715-c725-7122-86ee-2f56b54be1cb.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, large mirror, toilet, and decorative elements at Aria in Syracuse, UT.",
        "public_id": "01a01715-c725-7122-86ee-2f56b54be1cb",
        "storage_key": "property/6767906449166425/01a01715-c725-7122-86ee-2f56b54be1cb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience luxury in this modern bathroom, featuring a sleek double vanity, a spacious mirror, and elegant fixtures for a spa-like feel.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, large mirror, toilet, and decorative elements at Aria in Syracuse, UT.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_23c3c205-215e-411a-9e09-f31d9fa06d4c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Layton Aquarium & Wildlife",
      "poi_type": "Entertainment",
      "poi_address": "1201 N Hill Field Rd #1072, Layton, UT 84041, USA",
      "poi_short_description": "Aquarium with themed habitats & hands-on activities, feeding stations & snorkeling with stingrays.",
      "poi_long_description": "People say this aquarium offers a variety of animals, including fish, reptiles, and mammals, and provides opportunities for interactive experiences like feeding and petting. They highlight the reasonable prices, especially with the VIP wristbands, and the fun, engaging atmosphere suitable for children. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJC1ZNar8DU4cRcPr2kqECyWY/photos/AcnlKN3_P7SW_KXpP0LqPNVQtVINm6htg1QvBTrmGFVqdfQPXgBY7NZFRQzLx3tHYB9RtXlPFqAnrRYgPnre-7ASeMSJtCma6teibdgjl9QTE3YTy5SRe2i_96RQdlQG9rNID7wOVkjDboE2Z_2PuDLS_4SCPmO_vSibnj2YyUcOacirBtxaoVbrVgn0TcQJtUKrUcVF8MHnnXSq3K5rkXcTF3vmw95mh0n7sCvxtihBOpglhRoH2dsxvA247feLgam5GWMegUNHaI8P5HjAvQk04fko-LHeO8BhJsnru39a0XXGLA/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=614&maxHeightPx=406",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.laytonaquarium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7406453955166141040&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "layton-aquarium--wildlife",
      "poi_latitude": "41.0786592",
      "poi_longitude": "-111.9773245",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 385-381-6783",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc19-7337-8951-15907c738e3a",
        "storage_key": "property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC1ZNar8DU4cRcPr2kqECyWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_eccecfa3-1f5c-4477-82c5-9c153e789fa9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "FatCats Clinton",
      "poi_type": "Entertainment",
      "poi_address": "2062 W 1800 N, Clinton, UT 84015, USA",
      "poi_short_description": "Family-friendly attraction offering movies, bowling, an arcade, food and drinks.",
      "poi_long_description": "People say this movie theater offers a fun arcade, bowling, and a theater experience with comfortable seats and good sound quality. They highlight the great value, especially the bowling deal with pizza, drinks, and an arcade pass, and the enormous popcorn bucket refills. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJW8DNkT8bU4cRZugNLW69q38/photos/AcnlKN1L4sOT7CTX5A5XOW_oMiaPakRwXkblUL6t7rbsI2c2A5GzeGNx-oyv_KglUYF7nmwYVD2jsnnAPH__k6QL5GAWnco3KENDLxz_ovhioUtDXindihH-FHBrIacz-SvUqkeZTWTApksJggeYUXCYsi6JlA85ztviLdRwLbub1fQojte28-5vLM5CqZL-HRjkWaNJZj34dn3VWjv4wdPr6cGX54PiO3LRJLjFtK-Np_OxXQg02qj-wglwLx0NiWaT4cxS91xQjRCdGSuWG8R62t-tbQIyi5GjoDgjuRk0a267Jg/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4800&maxHeightPx=3201",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.fatcatsfun.com/locations/clinton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9199654944734308454&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fatcats-clinton",
      "poi_latitude": "41.1415037",
      "poi_longitude": "-112.0665713",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-416-2334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc19-7337-8951-15907c738e3a",
        "storage_key": "property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW8DNkT8bU4cRZugNLW69q38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_9e35c04e-4d26-4e6b-9bc9-bc6f16005362",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Kid Zone",
      "poi_type": "Entertainment",
      "poi_address": "340 W Antelope Dr Suites A101, Clearfield, UT 84015, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this indoor playground offers a wide variety of fun activities for kids of all ages, including slides, mazes, and a toddler area. They highlight the reasonable prices, clean facilities, and safe environment with cameras and attentive staff. They also like the spacious layout, comfortable seating for parents, and the availability of snacks and drinks. ",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJraS6bRkDU4cR1Hxmm4E6w8A/photos/AcnlKN3k3zmmxDBtKZqA_PGRVR7LSlKN3qWMZ4grlhK_5WV_5rd6U4Y6hVuEe1y5qJQUcbDTL1xXqLH0VP5I9_Sm6uVqgUf9SQvl_ur11mwtmoQ1ciq5eUjFEu1dZcx7KFhb2pmE5AELmO9jTKYAiNVoWaNASYgQNC8XLUGtbZSw6R9lqQcYaAghOrt8UUNge7mqSdERR2nOXdeXdy1984VviTcL_-ni-e79WeOPY63Oq6xPMP_3o_D3HVnPTse8oNVONZE8mSVnVJwO1D6mipOOtDWICbr8tWScIJJFvFiWjRN2ELfwva_w_-MLO3MmjAAs-HLKpzx_X2dhh8mUJnF_I8emp3Srr1e5-VBhPx-owZ---FKol9MVeabUhUPXlOeJQQc4wzTrjzO6PFak25nIcyKk9oHkIPPwxM59Uo9XH72PnPSG/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=3024&maxHeightPx=4032",
      "poi_featured_image_media": null,
      "poi_business_url": "http://kidzoneut.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13890010004073118932&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kid-zone",
      "poi_latitude": "41.0896304",
      "poi_longitude": "-112.0335273",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-784-7648",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc19-7337-8951-15907c738e3a",
        "storage_key": "property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJraS6bRkDU4cR1Hxmm4E6w8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "playground"
    },
    {
      "id": "custom_de451952-45f8-4f50-a1e5-6455571a3f97",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Axe N Smash",
      "poi_type": "Entertainment",
      "poi_address": "2146 N Main St #530, Layton, UT 84041, USA",
      "poi_short_description": "Games for families using axes and other weapons such as knives and stars.",
      "poi_long_description": "People say this amusement center offers a variety of fun activities, including axe throwing, a paint room, and a smash room. They highlight the many options for games, both single and group, and the fun, messy experience of the paint room. They also like the friendly and helpful staff, and the great service.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJr9IqSHUDU4cRF_574NzFGR0/photos/AcnlKN2U3Sj7tBJ07wmZjVdEyQ6xYLxRKUqOSsWouzQ0SR3DrcUc1nXdGL-VsxwclF7ecTRSUi1ZcUyfIJ0lfQg0PD8LBNkMrwYPWJxaYHyi_68mgNRXSNFIJK_88Z32XlY-bQv0jSsXGHopPWiTgZtaoPCJQsO694tkUVoASkA1GuaPAGfZpRbOYQtn3v6uQ3Dt1y4NtbxX4g0abBGOEnWlC2FarQo-RIG-MeqiJ8oMILbk9ke8hkIoGpZpVWEvY8PdU02JcA1zwvbEPZA8IzUESKP857gz_TULIiUDj2jSf-Idmw/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4000&maxHeightPx=3000",
      "poi_featured_image_media": null,
      "poi_business_url": "https://axensmash.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2096924653967375895&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "axe-n-smash",
      "poi_latitude": "41.0912246",
      "poi_longitude": "-112.0013873",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-900-7066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc19-7337-8951-15907c738e3a",
        "storage_key": "property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr9IqSHUDU4cRF_574NzFGR0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_fae0cbc2-dd5a-4284-8e8e-230ee2934cd4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "UEC Syracuse Stadium 6",
      "poi_type": "Entertainment",
      "poi_address": "2428 W 1700 S, Syracuse, UT 84075, USA",
      "poi_short_description": "Standard theater featuring current films, plus a concession stand with a variety of eats.",
      "poi_long_description": "Standard theater featuring current films, plus a concession stand with a variety of eats.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJcViubWcbU4cR4WelMcybq_w/photos/AcnlKN2xqbfzanrSPrMQ4gWCDQkuz-mEbl89at-kUnDjNBsWmWFibzCPidGsWEXv9wAX4aSiYfWUy4dgUaq52wucWq0G6K5TjZbnlyOCZ5M4YkDp4obqeGXlPvVpcg-JnHFkzEZwMvLicNZ4GhDzCVIormnNLcnGh8xprAN8pmmersWIUPAaMG_m5_8s0DGbT7GVKbJtXFng7-aNLY4KB3FYNYKMr91X8aF8BnOb82I0swkU2VcgDl2sY3DsAPkkfjmQdkQKjLHuV4bJLRKWeksb0_dashfEVNkQEKKTXOQDXFdtPwNf3rUnwbVISh9vs8Bfr4-DFpG_IuTeGZrD3AyWbF8_TyjBK-lGKp8Bt7S8KFqZcBduxzPYUXeUH95mfNJgD0mdCjuWhCGrPTNSqXUmgAwbFtQNN2b1i_S97520d_ibtDM4/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=3024&maxHeightPx=4032",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.uecmovies.com/movie-theatres/utah/syracuse/uec-syracuse",
      "poi_directions_map_url": "https://maps.google.com/?cid=18206817219883919329&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "uec-syracuse-stadium-6",
      "poi_latitude": "41.0899824",
      "poi_longitude": "-112.073053",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-775-0836",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c9-a54b-734b-958e-de3e1ee6a9e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c9-a54b-734b-958e-de3e1ee6a9e6",
        "storage_key": "property/6767906449166425/019d02c9-a54b-734b-958e-de3e1ee6a9e6.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJcViubWcbU4cR4WelMcybq_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_e09505e6-c34a-4d03-987e-4536e494a6a2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "The Rush Funplex",
      "poi_type": "Entertainment",
      "poi_address": "1806 S 2000 W, Syracuse, UT 84075, USA",
      "poi_short_description": "Multipurpose space featuring family-friendly attractions like bowling, go-karts, laser tag and mini golf.",
      "poi_long_description": "People say this amusement center offers a wide variety of activities, including go-karts, laser tag, bowling, mini golf, and a foam pit. They also highlight the fun, family-friendly vibe and the helpful staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ5wvWOlkbU4cR4605HiM9EyU/photos/AcnlKN3U9Cp5MQE70jUMY8yW8jaayQgCDTmBDT4W2LLZAh0eDAmapgPwY7V_flVZZdz84Hepe6Bt2xy8ZUo6a5JXh-sKEr7N8LbQqlahFCQ2Ug9lhX3b_qbpQTZUEJJ8H6UhmS73OLiRzePz0mAFAhJ5fliaZTqMGmvNKP6P8NfvOTWQm2YDwKlb4LT1MQbp1Ymca7ja28QjHCba9tyvGnQrbXF-7B0JMrYqzMOhjflJR4P6lP-iTxr_K_rTOa-Dsswsw1_EHV0cV6a176cjL5hqr4MifE1SfYEJBkwC-9eneQcdLQ/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1732&maxHeightPx=974",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.therushfunplex.com/syracuse-ut",
      "poi_directions_map_url": "https://maps.google.com/?cid=2671546225001082339&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-rush-funplex",
      "poi_latitude": "41.0877107",
      "poi_longitude": "-112.0666341",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-609-5467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc19-7337-8951-15907c738e3a",
        "storage_key": "property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wvWOlkbU4cR4605HiM9EyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_5ab583c9-1cf1-4bd0-b18a-7b4d0dcff479",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Indy Clover",
      "poi_type": "Shopping & Retail",
      "poi_address": "2058 Antelope Dr #103, Syracuse, UT 84075, USA",
      "poi_short_description": "Consignment shop selling used clothing for women and children, plus home accessories and shoes.",
      "poi_long_description": "People say this thrift store offers a wide variety of clothes in different styles and sizes, with many finding lucky treasures. They highlight the great deals and fun, cute vibe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJeRh8xr8bU4cRmBdDnJNXD6o/photos/AcnlKN27amM1Rc_XwaCpHE75MVHgcg7MWyiPltYIVXd4Left6xmS4qTeDBBy2z5Gj5IqneSKh7W8TvkSB2G3vvEgtQgLEmyjZbvGBNgeMtsxVbQywtCMiek_ry--juxj7d4Tlx8TS102qxoEu6OXlFA9BztDcrTdT36dSIVjFHegCYHgkBDy1kTvbb8NAkzwG73ho3g62y4qVK7aRcrCKKwtWHZaMFtgG96mVbeWuuMYXNluQDl3hYd2_1pzKhEiGeqGdWSLYBBLTCGtMNb7TUHypqZM6GWuxZnNM5n-bwbpmc4DywCiR40uCXiPFK9glcx-LP5g_miMXdp2uXyIkecLUhGWxHIRJFfCdF0fHTiuj-laRgV2QJtdZnu37Qdn_rCsJdd8bxAqB94vdNuWCjCzXXkwh9hWPhP8jtqNdkScuXSOhQ/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=3024&maxHeightPx=4032",
      "poi_featured_image_media": null,
      "poi_business_url": "https://indyclover.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12254109402591860632&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "indy-clover",
      "poi_latitude": "41.0895651",
      "poi_longitude": "-112.0662354",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-645-5222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b835-72ab-a221-bf96f97585fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b835-72ab-a221-bf96f97585fa",
        "storage_key": "property/6767906449166425/019d02c7-b835-72ab-a221-bf96f97585fa.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJeRh8xr8bU4cRmBdDnJNXD6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_a8472bcb-3651-4a1c-9e69-66f1888b3e06",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Smith's",
      "poi_type": "Shopping & Retail",
      "poi_address": "951 W 1700 S, Syracuse, UT 84075, USA",
      "poi_short_description": "Typical supermaket carrying produce, meat & pantry staples, along with beer & liquor.",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, deli items, and meat. They also highlight the friendly and helpful staff, and the well-organized and clean store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJy5FyY6oEU4cR-c-qME-u6hw/photos/AcnlKN0Z-30hDWKl3S8OYM846E_egvZmv9skVPgKdMx4qiBLXMDgkFvoioaWGICq6KgYaA8n-P2L-65UHV5p7MzE_jMCXFhrlrg5Qar1SznrqN1-QU4iy8AKJ9hHckM9buWhZ78hDhViHwQuloCutPMY6K1l-uycELby-E8G97n1IU_4MmSYIlpXv5HiVLaqpFKZy0CUk0T7f6WTjhNExmZspiJmhuOvgByXzGdTsHzJxMU4ugFxHuZsTGNgtkkIweJB0f7ogLRMPGwiq1fkdKdY_HW50IviceECF4LWXxt_ivdi_yi3aEbcp8SbL0ANPs6jv5Qyok-8Fc3vMQl57NNBh_wLyPWXdqEB_Ch0iao7vMIzzS1qeDkKi1p0uouy_enSSk4W5_bZuaH-w2WPiYkDDP8z_-ZbU6ij2AMMrFZLEENUYw/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=3264&maxHeightPx=2448",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.smithsfoodanddrug.com/stores/grocery/ut/syracuse/951-w-1700-s-syracuse-ut/706/00142?cid=loc_70600142_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2083669432754425849&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "smiths",
      "poi_latitude": "41.0877884",
      "poi_longitude": "-112.0441157",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-773-5133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b824-757e-9c22-b429e7c36983.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b824-757e-9c22-b429e7c36983",
        "storage_key": "property/6767906449166425/019d02c7-b824-757e-9c22-b429e7c36983.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5FyY6oEU4cR-c-qME-u6hw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0e2e3830-7beb-4c41-972d-eb3f9e2891b7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Layton Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "1201 N Hill Field Rd, Layton, UT 84041, USA",
      "poi_short_description": "Brand-name retailers, casual eateries, an aquarium & movie theater are the draw at this lively mall.",
      "poi_long_description": "Brand-name retailers, casual eateries, an aquarium & movie theater are the draw at this lively mall.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJc855GzQCU4cRV4kv0-jQcK4/photos/AcnlKN0eeEnInFZPNoSj_uhfkrNDgsAF7H6ZD_Cdd9bSfxeYKnR8qZbgZczV7SUYzZ5ptIqhB7uhv0vhOGf7PyWW6iPki-2GcwOIJ5ZBahf4iHf6pv-LvhWTdmXQdVItu9fCqMI2aVxtAbMp6xku74Zxu7h08LlhoLMM0qWIej-pApsTsuo2z8RSSCdh_3HvciARy_xQGCSf-NTSZfrP3ZCgatjU4QVyimsx8uB6NULvKsJVHWFTRQcaauj4B_IL_Z2d9BAbo9TmEk8d5_yymB6hwkESLSmokomlFLeQJMdNHm81KY33a_LLDGB0F8zimPC9_ONPjblEmRVoKEgP6MEY9Q1mwG03wn2yKkNJbB1qT-AfaJlBlx3gwLjOlM91zkSJSF1i2IMX2vFYr8XMcWYo_Nx6wNkxD_oaUT2_j0UIFw_sVRU/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=3024",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.shoplaytonhills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12569776258385152343&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "layton-hills-mall",
      "poi_latitude": "41.07839999999999",
      "poi_longitude": "-111.9775",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-546-3471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b835-72ab-a221-bf96f97585fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b835-72ab-a221-bf96f97585fa",
        "storage_key": "property/6767906449166425/019d02c7-b835-72ab-a221-bf96f97585fa.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJc855GzQCU4cRV4kv0-jQcK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_2e5b4a9b-b1c4-4c17-a506-82bf8bff7ae8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "Park Plaza, 1814 W 1800 N, Clinton, UT 84015, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "People say this department store offers a wide selection of clothing, shoes, and other products, including a variety of sizes and brands. They also highlight the friendly and helpful service, and the convenient Amazon return station.\n\nOther reviews mention the deals can be inconsistent.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJw1gpMcYaU4cRs-29s66EHio/photos/AcnlKN3Jwr9uhym5UhjQSi92LY2GXLRDc4NTe1KfTZD3jhvciatD-UG_VgkQL4gnhJ0ZokACrCTjcwILF7f_miElRK-X-mF4LPcd8Mw1a-2Md3_UGnueVZQMJrq1GE6colgzkrw8OQ_C6j_pI1CDKAcWYAy6oS2PMaYpjIxbQ9uxZrhu3MUk5ApmA6Fy9PzJBJz2znB6iMJQem7ugG3u9lA06D2z-tD3U_BQ35oC_WmkFl-fj1tE0N7uBjmOQPtU2R_cnKhPj1jyQh0sWLb3LaWYP6NBWhx1e_HaJLKwWsyFeqoXBIQPs52TRqZWpBjfYa-OeFfNHU7MgpA7spQzQ675oiXw2UGgaoQyBzq6zmpsvPhYHSJ2TeXCqP8e_Z5lkTyU-RRQJqRAgdnjlz2_oCwcrZmg9eN4901fTJzLSpDGIwy45yT5/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=3984&maxHeightPx=2988",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.kohls.com/stores/ut/clinton-1320.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3035009084769037747&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohls",
      "poi_latitude": "41.1411103",
      "poi_longitude": "-112.0604918",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-525-1777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b835-72ab-a221-bf96f97585fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b835-72ab-a221-bf96f97585fa",
        "storage_key": "property/6767906449166425/019d02c7-b835-72ab-a221-bf96f97585fa.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJw1gpMcYaU4cRs-29s66EHio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_f56c4424-e244-4d4b-94a5-53e0b1d6e2d3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "815 W 2000 N, Layton, UT 84041, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a wide variety of items and convenient shopping options, such as grocery pickup.\n\nOther reviews mention the return policy can be inconsistent and the service can be unhelpful.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJszxwLZIDU4cRF-jE3dEnsRE/photos/AcnlKN3U_Iyus2wIXMK79pZ8Eg7CZpVHSdBqwXFj1AuuuMa0n9eBRSG-enWS2mrxHQeokWiH5FoPsg2NzLspzb7fuq4qXLspsukxfk7QDaIuvvOiX_pjngCmD6g_GliDzzwXFKFKWeN-wR_m4xjLjpLhthJE3ASVu9_z-xOGDmvXPnlJsuGhPOClSeLUDK2M2bQe2D1q2guKCqBunL4ogG3rcW_YD5ewIuQFlnNIrZjlWlb7XEdHqO7yLlQNNWh3nJgdrqJeipIsYIjhyrRH8H1MPaf-1XvPpD1d6-_GOTqW95sV11BCvPM-dI8pR1MPxeiN7WRJ37DSHuav_IuC18UKHapmE5pGUs-Lod6ZdPaA3W4HtHyoO78-hzZ5EAkD2r-Pksc-jqTPOPNfIPZHhq9k3kkBbmfai_w-1e0ERzvi3ok/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=3024",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.target.com/sl/layton/1755",
      "poi_directions_map_url": "https://maps.google.com/?cid=1274843951844878359&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "41.08771249999999",
      "poi_longitude": "-111.980325",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-773-0287",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b835-72ab-a221-bf96f97585fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b835-72ab-a221-bf96f97585fa",
        "storage_key": "property/6767906449166425/019d02c7-b835-72ab-a221-bf96f97585fa.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJszxwLZIDU4cRF-jE3dEnsRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_658d6b8b-4308-4f73-a280-e10586aec765",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Weller's Bistro",
      "poi_type": "Restaurants",
      "poi_address": "197 N Main St, Layton, UT 84041, USA",
      "poi_short_description": "Easygoing spot showcasing German cuisine along with pizza, salads & sandwiches, plus weekend brunch.",
      "poi_long_description": "People say this German restaurant serves delicious schnitzel, spaetzle, and other authentic German dishes. They highlight the generous portions, flavorful sauces, and the cozy, quaint atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJA875fLcDU4cRG0SpUTJhXpU/photos/AcnlKN2XDbuGoXhl-OsQfZz180lOfPNNvoQNyQLgTBF_r35rUKmrbYV5Rm3khjPl0fHDy3bkyDoTWTOlB2Wvh59CdvXzyKtTCldmonzF2IFAZGEb1BcVFY3dIdFX_yA2ynzDR-sdK1i3e3ccwVBOKDPnMOzaZv1LXrzqQ6WLOL5fmYbN1rtOHOVrho7ogQgmcIjbelM3EUOP3dLAkIVDn2WmfQMOMbMbC5xyjFvzPLDF7Gw5g0XU4IjLtMfty93mwKy7k9snKFHrHEPnMAWK4Grmi6JUFNrJ1aQbK11hhTbBLir8omU6gvZxjRIYqgemoXqjb5cniXyOd44Yf8XIfxKMi3LroN9ZQA_rxNbSyO4u5me91WjFfe__gfHC_uq_ZoTeHMSiPcB-Le5PuL5pbhVIByUSbBliCApTMDt-KHolfCkPWA/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=3024",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.wellersbistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10763147028208370715&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wellers-bistro",
      "poi_latitude": "41.0629095",
      "poi_longitude": "-111.9690834",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 385-888-9531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b822-70e4-8bb1-84aa613b1a8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b822-70e4-8bb1-84aa613b1a8f",
        "storage_key": "property/6767906449166425/019d02c7-b822-70e4-8bb1-84aa613b1a8f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA875fLcDU4cRG0SpUTJhXpU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_aa515e27-e7de-4704-bcc3-aedf4e810e8a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Ramen Garden Syracuse",
      "poi_type": "Restaurants",
      "poi_address": "2058 W 1700 S #106, Syracuse, UT 84075, USA",
      "poi_short_description": "Friendly place for ramen noodle soups as well as rice dishes.",
      "poi_long_description": "People say this ramen restaurant serves delicious ramen, udon noodles, sushi burritos, and potstickers. They highlight the generous portions, reasonable prices, and quick service. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJ_X2VVJUbU4cRc6z06H-bUlw/photos/AcnlKN0TxragNAYKhqzsfkk9eOELuPqAAnmjkwXN8K3GCjrR7RiVXlpK3ZSydgJ49o49FilcsaS6eUQ-DVvPjCUolWYiwCJ7oOd--wDn6Ek_2kdXrCfQXaCJlhvdPMrD-JmlzxfwRvXXgpiF3gvIh8gd5Pxt90_knKMaDuVMj2CqeXCLSrnJZJkoiIaGQTm9dhcBfqHCQmUbrFy4RH2hRfoll-9r8EFihRUz6r3iXRIsxHYdLEOGcbWTmrA8VfVK53LQ1kejOQ0mwWy4fZfBgsjE_pKotlXUwuThXZBdLWEVDkFgqA/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=4032&maxHeightPx=3024",
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ramengarden2ut.com/order",
      "poi_directions_map_url": "https://maps.google.com/?cid=6652550573251144819&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ramen-garden-syracuse",
      "poi_latitude": "41.0894957",
      "poi_longitude": "-112.0661274",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-825-8848",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b822-70e4-8bb1-84aa613b1a8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b822-70e4-8bb1-84aa613b1a8f",
        "storage_key": "property/6767906449166425/019d02c7-b822-70e4-8bb1-84aa613b1a8f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_X2VVJUbU4cRc6z06H-bUlw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ramen_restaurant"
    },
    {
      "id": "custom_5f60b493-925b-43fc-a73b-15f5f149b2fa",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Hook & Reel Cajun Seafood & Bar",
      "poi_type": "Restaurants",
      "poi_address": "1508 Woodland Park Dr, Layton, UT 84041, USA",
      "poi_short_description": "Fun eatery specializing in seafood boils with spicy sauces.",
      "poi_long_description": "People say this restaurant serves delicious seafood boils, including shrimp and Dungeness crab, with generous portions and flavorful seasoning. They highlight the casual and relaxed vibe, perfect for a laid-back meal with family or friends. They also like the friendly, welcoming, and patient staff who provide helpful tips on enjoying the meal.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJETErWb8DU4cRosayQBWe-vA/photos/AcnlKN1Yi6mYfsYqgaeTx9Lo3m21q1exkAlm5ljlVWORAJlo7ae6xJ8-pWtBLS23MPpXb4xkOdHHu2GJhJFb_fXZY18l5BUzE-ZSLCafSGfzMUMkdG60sbwDpuR39NGqxPQg5fciizCXYeHAZiEo0V8aZ6OLGksgcTJITsjHDU8XGFl2Jb1X1_s_kGN4hSqlm5nPZbzkJIzSTgChN1B6YNl0LISVCZoEeqA8aiJmmuNLS7NVVdsHfuOMRODJc5-TXgAbxxXyAbje4KYs_FM6CbMuRCk0fYkheSIhFIFF1YrlnFTRsQ/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=1080&maxHeightPx=810",
      "poi_featured_image_media": null,
      "poi_business_url": "https://hookreel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17364365127397328546&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hook--reel-cajun-seafood--bar",
      "poi_latitude": "41.0811648",
      "poi_longitude": "-111.981984",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 385-278-6666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b822-70e4-8bb1-84aa613b1a8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b822-70e4-8bb1-84aa613b1a8f",
        "storage_key": "property/6767906449166425/019d02c7-b822-70e4-8bb1-84aa613b1a8f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJETErWb8DU4cRosayQBWe-vA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0773e45e-a803-465e-88b2-2ba67c993499",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "The Crepêry Syracuse",
      "poi_type": "Restaurants",
      "poi_address": "1863 W 700 S Suite 2, Syracuse, UT 84075, USA",
      "poi_short_description": "Casual spot for sweet and savory crepes (including build-your-own options) as well as coffee and tea options.",
      "poi_long_description": "People say this breakfast restaurant serves delicious sweet and savory crepes, with options like the Nutella with strawberries and the Buddha Gouda. They highlight the fair pricing, fun and cozy atmosphere with pretty plants, and the friendly and helpful staff. They also like the study hour discount.",
      "poi_featured_image": "https://places.googleapis.com/v1/places/ChIJK3-I2o4bU4cRDZtiNBl2DOU/photos/AcnlKN2hmVOkajsxubK6IcJqobO1EvK0LeFKyoCp2OuS2Ntj0V6vQmYFOVlx5kLlqi4phlaocsiitW8sGut8oZ4pLJVe6h0myxMKyegduJIG7Q3e0ZUuqb8FTQwW_wPGHgXE7m2rRTx5Ah8HbkZ7D683d1w46sdr5ZkDRoJcO54ATPp8Zm4gvVrUENgOScAP5cw0I_p7rYooxvrA7hMgIDM-8nyWnWGnsOTBQ2jvfwvPV777VfLWW4eR0OiDjMYrd-U25hKjCN0f2o0hQnMCwmny0gnnnkUEMuMlKVaPupVEEWxt8wgKDIt3a6crq8v3gyovaBEIxzvKYwoeNU0JHKOYd_rupuX5zhfE1ck7CQJQvljl7Oj8ulxOdxgsgB-d-Q-7JwIEhJobjmo_-1yFpgYqGIr93BbARcsXso5Qimxrb_51nY1eS6pXXG-cfr1LBQ-y/media?key=AIzaSyBY3Rm8CFy30OZioNxXPu9YeJkIdGZA9Co&maxWidthPx=3600&maxHeightPx=4800",
      "poi_featured_image_media": null,
      "poi_business_url": "https://the-crepery-syracuse.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16504696585031162637&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-crepry-syracuse",
      "poi_latitude": "41.1034798",
      "poi_longitude": "-112.0620447",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 385-423-2356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b822-70e4-8bb1-84aa613b1a8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b822-70e4-8bb1-84aa613b1a8f",
        "storage_key": "property/6767906449166425/019d02c7-b822-70e4-8bb1-84aa613b1a8f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJK3-I2o4bU4cRDZtiNBl2DOU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_879bae4d-7dbf-43f2-805c-3d4d782796d4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Weber State University Davis",
      "poi_type": "Education",
      "poi_address": "2750 University Park Blvd, Layton, UT 84041, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-9285-72e0-b4ce-6007ab284e93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9285-72e0-b4ce-6007ab284e93",
        "storage_key": "property/6767906449166425/019d02c7-9285-72e0-b4ce-6007ab284e93.webp",
        "width": 500,
        "height": 289
      },
      "poi_business_url": "http://weber.edu/WSUDavis/default.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=1835674165936088418&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "weber-state-university-davis",
      "poi_latitude": "41.0988823",
      "poi_longitude": "-111.9825211",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 801-395-3555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b821-73b8-885c-a14797828599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b821-73b8-885c-a14797828599",
        "storage_key": "property/6767906449166425/019d02c7-b821-73b8-885c-a14797828599.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSQgivIkDU4cRYmX7l-2feRk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7255574a-5bff-4d6f-8c2e-f8838f1d746f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2076 N Main St, Layton, UT 84041, USA",
      "poi_short_description": "Spacious gym with an indoor pool, yoga classes and kid care, plus personal training services.",
      "poi_long_description": "People say this gym offers a variety of machines, a hot tub, and a steam room. They also highlight the friendly and helpful staff, and the clean facilities.\n\nOther reviews mention the childcare appointments can be difficult to schedule.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-9bb1-77e5-a760-f90cbb0aebbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9bb1-77e5-a760-f90cbb0aebbe",
        "storage_key": "property/6767906449166425/019d02c7-9bb1-77e5-a760-f90cbb0aebbe.webp",
        "width": 1280,
        "height": 730
      },
      "poi_business_url": "https://vasafitness.com/locations/ut/layton/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=3220395330247314625&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "41.0908196",
      "poi_longitude": "-111.9998503",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 801-771-8272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc19-7337-8951-15907c738e3a",
        "storage_key": "property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW5Ct5XgDU4cRwcy3j30ksSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f7fa5b2f-5d26-4b79-b9b1-afd69c3d6cd5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1839 Woodland Park Dr, Layton, UT 84041, USA",
      "poi_short_description": "Gym chain with membership required offers a variety of equipment, plus massage chairs.",
      "poi_long_description": "People say this fitness center offers a wide variety of clean, well-maintained equipment, including multiple machines of the same type, and a spacious layout. They highlight the excellent value, the chill and comfortable vibe, and the friendly and helpful staff. They also like the clean locker rooms and spa amenities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-9d35-744a-ae97-2bb3305943d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9d35-744a-ae97-2bb3305943d2",
        "storage_key": "property/6767906449166425/019d02c7-9d35-744a-ae97-2bb3305943d2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/layton-ut?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16864352640367830971&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "41.0866055",
      "poi_longitude": "-111.980807",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-477-5012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc19-7337-8951-15907c738e3a",
        "storage_key": "property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUTJ39UYDU4cRu6cLEGA3Cuo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_e3f38697-0622-4f92-9b26-dd8bf02b4a90",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "MedVet Northern Utah",
      "poi_type": "Health and Wellness",
      "poi_address": "2465 N Main St #12a, Sunset, UT 84015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-a003-75ca-85be-7bd6b4497a5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a003-75ca-85be-7bd6b4497a5c",
        "storage_key": "property/6767906449166425/019d02c7-a003-75ca-85be-7bd6b4497a5c.webp",
        "width": 1025,
        "height": 1025
      },
      "poi_business_url": "https://www.medvet.com/location/northern-utah/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14561298773400553755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "medvet-northern-utah",
      "poi_latitude": "41.1507647",
      "poi_longitude": "-112.0265163",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-776-8118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc19-7337-8951-15907c738e3a",
        "storage_key": "property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMwgwikAFU4cRGwnf2BUgFMo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_2eac19ef-eda6-47fe-9327-503a1cec9789",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Bayview Animal Hospital Layton",
      "poi_type": "Health and Wellness",
      "poi_address": "2215 W Gentile St, Layton, UT 84041, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-a02a-75a9-8355-d68ac122cfb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a02a-75a9-8355-d68ac122cfb8",
        "storage_key": "property/6767906449166425/019d02c7-a02a-75a9-8355-d68ac122cfb8.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://bayviewanimalhospital.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11688497373125755451&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bayview-animal-hospital-layton",
      "poi_latitude": "41.0598203",
      "poi_longitude": "-112.0077087",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-784-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc19-7337-8951-15907c738e3a",
        "storage_key": "property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ44HMmpQDU4cRO0I_u27iNaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_9fcd9ed8-3e30-4919-9a65-3a6056d20981",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1792 S 1000 W, Syracuse, UT 84075, USA",
      "poi_short_description": "Clean fitness facility offering weights, treadmills, cardio equipment, group classes and personal trainers.",
      "poi_long_description": "People say this gym offers a wide variety of machines and free weights. They also highlight the friendly and welcoming atmosphere, and the helpful and cheerful staff.\n\nOther reviews mention the membership can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-9b36-745c-b8db-462c1382a284.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-9b36-745c-b8db-462c1382a284",
        "storage_key": "property/6767906449166425/019d02c7-9b36-745c-b8db-462c1382a284.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/syracuse-gym-on-s-1000-w/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13600586654899530692&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "41.0877037",
      "poi_longitude": "-112.046791",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 801-528-5478",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc19-7337-8951-15907c738e3a",
        "storage_key": "property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY-_jEZEDU4cRxGs07oD9vrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4000c5d0-c7fe-4872-a5de-dd1ee7b09cc2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Tammy-Lynn Nails & Spa",
      "poi_type": "Health and Wellness",
      "poi_address": "7040 1776 N Hill Field Rd, Layton, UT 84041, USA",
      "poi_short_description": "Relaxed salon offering a variety of manicures and pedicures, as well as waxing and facial treatments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-a275-764a-a874-0e84d6f2889b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a275-764a-a874-0e84d6f2889b",
        "storage_key": "property/6767906449166425/019d02c7-a275-764a-a874-0e84d6f2889b.webp",
        "width": 1200,
        "height": 1200
      },
      "poi_business_url": "https://tammylynnnailspalayton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2429353421081484870&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tammy-lynn-nails--spa",
      "poi_latitude": "41.0860175",
      "poi_longitude": "-111.9729673",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 801-774-9791",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc19-7337-8951-15907c738e3a",
        "storage_key": "property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwxOP_uoDU4cRRh5xsRDMtiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_67afceeb-2f1a-420e-99c3-07205ffdf642",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Intermountain Health Layton Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "201 W Layton Pkwy, Layton, UT 84041, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-a339-701f-b30f-d645e8d03ca1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a339-701f-b30f-d645e8d03ca1",
        "storage_key": "property/6767906449166425/019d02c7-a339-701f-b30f-d645e8d03ca1.webp",
        "width": 1279,
        "height": 1280
      },
      "poi_business_url": "https://intermountainhealthcare.org/locations/layton-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=7124467877409736122&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "intermountain-health-layton-hospital",
      "poi_latitude": "41.0523124",
      "poi_longitude": "-111.9686674",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 801-543-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc55-7783-ac73-e9e1aacfe585.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc55-7783-ac73-e9e1aacfe585",
        "storage_key": "property/6767906449166425/019d02c7-bc55-7783-ac73-e9e1aacfe585.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-yLzCWQDU4cRukWwlskx32I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a521e748-df42-4bb4-af97-b60e951dab35",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Ogden Clinic Kaysville",
      "poi_type": "Health and Wellness",
      "poi_address": "1351 W 200 N, Kaysville, UT 84037, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-a4b2-736f-98d8-6cadeeda2d0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a4b2-736f-98d8-6cadeeda2d0e",
        "storage_key": "property/6767906449166425/019d02c7-a4b2-736f-98d8-6cadeeda2d0e.webp",
        "width": 1280,
        "height": 633
      },
      "poi_business_url": "https://www.ogdenclinic.com/locations/kaysville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11924116891568533769&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ogden-clinic-kaysville",
      "poi_latitude": "41.0376241",
      "poi_longitude": "-111.9650314",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 801-383-3420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc55-7783-ac73-e9e1aacfe585.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc55-7783-ac73-e9e1aacfe585",
        "storage_key": "property/6767906449166425/019d02c7-bc55-7783-ac73-e9e1aacfe585.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_4W1Mq4DU4cRCXEt3iL5eqU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_4fb58881-c4bf-4a80-912d-abf14e622d6f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Ellison Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "700 N 2200 W, Layton, UT 84041, USA",
      "poi_short_description": "Sprawling park featuring ballfields, a playground and a skate park.",
      "poi_long_description": "People say this park offers baseball fields, pickleball courts, a playground, a skate park, and a splash pad. They highlight the wide open fields, the fun splash pad, and the well-maintained facilities. They also like the convenient picnic areas and the variety of activities available for all ages. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-a527-706e-b451-9b2fad813ddc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a527-706e-b451-9b2fad813ddc",
        "storage_key": "property/6767906449166425/019d02c7-a527-706e-b451-9b2fad813ddc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.laytoncity.org/LC/Parks/Park/Ellison%20Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13498440106419831118&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ellison-park",
      "poi_latitude": "41.0693359",
      "poi_longitude": "-112.0024351",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc55-7783-ac73-ef9672282c46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc55-7783-ac73-ef9672282c46",
        "storage_key": "property/6767906449166425/019d02c7-bc55-7783-ac73-ef9672282c46.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJsbKwXQgDU4cRTkEKTcIXVLs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0597880a-b288-4a28-b835-1b9f76197e70",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Great Salt Lake Shorelands Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1002 S 3200 W, Layton, UT 84041, USA",
      "poi_short_description": "Tranquil nature reserve with a boardwalk loop and a 4-story observation tower.",
      "poi_long_description": "People say this nature preserve offers a boardwalk loop with a tower for sightseeing, and opportunities for birdwatching and wildlife viewing. They highlight the peaceful and beautiful atmosphere, and the easy, accessible trail suitable for all ages. They also like the ample parking and the availability of restrooms and a water station.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-a825-724c-9d21-14ed219fa9ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a825-724c-9d21-14ed219fa9ed",
        "storage_key": "property/6767906449166425/019d02c7-a825-724c-9d21-14ed219fa9ed.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.nature.org/en-us/get-involved/how-to-help/places-we-protect/the-great-salt-lake-shorelands-preserve/?en_txn1=bl.ch_ut.eg.x.g",
      "poi_directions_map_url": "https://maps.google.com/?cid=14828837649472574480&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "great-salt-lake-shorelands-preserve",
      "poi_latitude": "41.0456671",
      "poi_longitude": "-112.0264198",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 801-531-0999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc55-7783-ac73-ef9672282c46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc55-7783-ac73-ef9672282c46",
        "storage_key": "property/6767906449166425/019d02c7-bc55-7783-ac73-ef9672282c46.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJsSNQG90CU4cREFTAkEadys0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_803cea70-b82d-4533-92a4-993d7e55aaf0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Layton Commons Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "437 N Wasatch Dr, Layton, UT 84041, USA",
      "poi_short_description": "Green park featuring baseball fields and a swimming pool, along with kid-centric activities, plus an amphitheater.",
      "poi_long_description": "People say this park offers a duck pond, playground, walking trail, and pavilions, and hosts events like concerts and a Christmas lights display. They highlight the family-friendly atmosphere, mature trees providing shade, and well-maintained grounds. They also like the clean restrooms and the train ride during the Christmas lights display.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-a8fe-75e9-bac8-746bc570941d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a8fe-75e9-bac8-746bc570941d",
        "storage_key": "property/6767906449166425/019d02c7-a8fe-75e9-bac8-746bc570941d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.laytoncity.org/LC/Parks/Park/Layton%20Commons%20Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14278497796568508606&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "layton-commons-park",
      "poi_latitude": "41.0671116",
      "poi_longitude": "-111.9619371",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 801-336-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc55-7783-ac73-ef9672282c46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc55-7783-ac73-ef9672282c46",
        "storage_key": "property/6767906449166425/019d02c7-bc55-7783-ac73-ef9672282c46.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL09ZKS0CU4cRvuipYhhqJ8Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bee9eb77-a6b5-4c83-9f54-5d9d25fbf442",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Barnes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "950 W 200 N, Kaysville, UT 84037, USA",
      "poi_short_description": "Pet-friendly park with playgrounds and basketball courts plus grassy area for games.",
      "poi_long_description": "People say this park offers well-maintained baseball fields, pavilions, playgrounds, and restrooms. They highlight the beautiful trees, walking trails, and open spaces, as well as the clean and peaceful atmosphere. They also like the convenient parking and the variety of recreational options, including basketball and volleyball courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-a9f1-72a9-867a-fae1a7bc8336.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-a9f1-72a9-867a-fae1a7bc8336",
        "storage_key": "property/6767906449166425/019d02c7-a9f1-72a9-867a-fae1a7bc8336.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kaysville.gov/Facilities/Facility/Details/Barnes-Park-1",
      "poi_directions_map_url": "https://maps.google.com/?cid=2439860957028695729&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barnes-park",
      "poi_latitude": "41.0407113",
      "poi_longitude": "-111.9596241",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 801-544-1788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc55-7783-ac73-ef9672282c46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc55-7783-ac73-ef9672282c46",
        "storage_key": "property/6767906449166425/019d02c7-bc55-7783-ac73-ef9672282c46.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy2HRqxsCU4cRsT4KDZ0g3CE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a60f15b2-85f2-44db-9725-f49981278f3b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Jensen Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3176 S Bluff Rd, Syracuse, UT 84075, USA",
      "poi_short_description": "Tranquil nature park featuring a paved trail, ponds, fishing, and birds.",
      "poi_long_description": "People say this park offers a fishing pond, walking and cycling trails, picnic tables, a boat ramp for motorless boats, pavilions, and scenic views. They highlight the peaceful and family-friendly vibe, and the clean and well-maintained facilities. They also like the convenient parking and accessible restrooms. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-ab0d-72ab-a83b-27f3b2aaedc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-ab0d-72ab-a83b-27f3b2aaedc3",
        "storage_key": "property/6767906449166425/019d02c7-ab0d-72ab-a83b-27f3b2aaedc3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.syracuserecreation.com/jensen-nature-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5185701560523372871&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jensen-nature-park",
      "poi_latitude": "41.0664944",
      "poi_longitude": "-112.0528306",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 801-614-9660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc55-7783-ac73-ef9672282c46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc55-7783-ac73-ef9672282c46",
        "storage_key": "property/6767906449166425/019d02c7-bc55-7783-ac73-ef9672282c46.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2yCFFsocU4cRRzkvIhhQ90c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2bd90f8b-062b-48bf-b681-6d4a4a405750",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Layton",
      "poi_type": "Transportation & Transit",
      "poi_address": "Layton, UT 84041, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-adaf-74b4-a59f-71e654054f45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-adaf-74b4-a59f-71e654054f45",
        "storage_key": "property/6767906449166425/019d02c7-adaf-74b4-a59f-71e654054f45.webp",
        "width": 988,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14408732956242668890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "layton",
      "poi_latitude": "41.0567798",
      "poi_longitude": "-111.9648463",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bf9a-708c-bfdf-9c54c416f616.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bf9a-708c-bfdf-9c54c416f616",
        "storage_key": "property/6767906449166425/019d02c7-bf9a-708c-bfdf-9c54c416f616.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJU4QCEDACU4cRWu1OcEga9sc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_5c32f8cf-ef6e-4158-a547-eaa2b1428f5f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Clearfield",
      "poi_type": "Transportation & Transit",
      "poi_address": "Clearfield, UT 84015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-af2d-75db-8006-bdace33a48b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-af2d-75db-8006-bdace33a48b3",
        "storage_key": "property/6767906449166425/019d02c7-af2d-75db-8006-bdace33a48b3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5556528518919894505&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clearfield",
      "poi_latitude": "41.0946064",
      "poi_longitude": "-112.0136996",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bf9a-708c-bfdf-9c54c416f616.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bf9a-708c-bfdf-9c54c416f616",
        "storage_key": "property/6767906449166425/019d02c7-bf9a-708c-bfdf-9c54c416f616.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJo7zBY50EU4cR6TWMij_BHE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_eb96a2d2-3050-43c3-87e5-c068dbefde3b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "West Point City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3200 W 300 N, West Point, UT 84015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-af0f-72d1-b83c-258f46ed7595.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-af0f-72d1-b83c-258f46ed7595",
        "storage_key": "property/6767906449166425/019d02c7-af0f-72d1-b83c-258f46ed7595.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.westpointcity.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13263858751474184677&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "west-point-city-hall",
      "poi_latitude": "41.1184716",
      "poi_longitude": "-112.0871804",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 801-776-0970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bfd8-746f-82b3-8443940eacda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bfd8-746f-82b3-8443940eacda",
        "storage_key": "property/6767906449166425/019d02c7-bfd8-746f-82b3-8443940eacda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJodWliP0aU4cR5TGTcEKxErg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_8e357e01-4283-4274-a3b1-6fa62b324e73",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Northrop Grumman Clearfield",
      "poi_type": "Major Employers & Offices",
      "poi_address": "C-14, 14 13th St, Clearfield, UT 84015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11383306958797582233&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northrop-grumman-clearfield",
      "poi_latitude": "41.0952381",
      "poi_longitude": "-112.0223789",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc19-7337-8951-15907c738e3a",
        "storage_key": "property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfwISNgUFU4cRma9cIF6h-Z0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_8a8e7a82-a63b-4499-a2c2-9345abcbbbcf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "SpaceStation 2.0",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Layton, UT 84041, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b138-72c5-946e-7f90b3af775f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-b138-72c5-946e-7f90b3af775f",
        "storage_key": "property/6767906449166425/019d02c7-b138-72c5-946e-7f90b3af775f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://spacestation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1893583952080668891&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "spacestation-20",
      "poi_latitude": "41.0644843",
      "poi_longitude": "-111.9893289",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc19-7337-8951-15907c738e3a",
        "storage_key": "property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS9vkRL0DU4cR2wgmYJJcRxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0f91e8e4-234c-4ba1-be6b-e99c5ddb4728",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Syracuse City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1979 W 1900 S, Syracuse, UT 84075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b250-76ef-94b2-fae6be9bca95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02c7-b250-76ef-94b2-fae6be9bca95",
        "storage_key": "property/6767906449166425/019d02c7-b250-76ef-94b2-fae6be9bca95.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://syracuseut.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5863775623697125836&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "syracuse-city-hall",
      "poi_latitude": "41.0855216",
      "poi_longitude": "-112.0639076",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 801-825-1477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bfd8-746f-82b3-8443940eacda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bfd8-746f-82b3-8443940eacda",
        "storage_key": "property/6767906449166425/019d02c7-bfd8-746f-82b3-8443940eacda.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6RfsK18bU4cRzNEPtdxQYFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_20063666-30df-453d-ba0b-1acc323ad89b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Acce Bldg Atk",
      "poi_type": "Major Employers & Offices",
      "poi_address": "120660026, C-14, 14 13th St, Clearfield, UT 84015, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10532526732830471274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "acce-bldg-atk",
      "poi_latitude": "41.0970799",
      "poi_longitude": "-112.0181906",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc19-7337-8951-15907c738e3a",
        "storage_key": "property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_ZQv9QFU4cRanSqgUINK5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5103d92c-93f9-4bb1-9850-8ec6d58c30ac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Thai Jasmine Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1662 S 2000 W, Syracuse, UT 84075, USA",
      "poi_short_description": "A simple, family-owned space with a menu that includes specialties from all regions of Thailand.",
      "poi_long_description": "People say this Thai restaurant serves tasty dishes, including spring rolls, beef soup, and Pad Thai. They highlight the generous portions, good prices, and great atmosphere for a date. They also like the kind and respectful service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019eb303-5e63-747d-8971-812316da17db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb303-5e63-747d-8971-812316da17db",
        "storage_key": "property/6767906449166425/019eb303-5e63-747d-8971-812316da17db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3489004925629689592&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "thai-jasmine-restaurant",
      "poi_latitude": "41.08975239999999",
      "poi_longitude": "-112.0649645",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-825-2719",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b822-70e4-8bb1-84aa613b1a8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b822-70e4-8bb1-84aa613b1a8f",
        "storage_key": "property/6767906449166425/019d02c7-b822-70e4-8bb1-84aa613b1a8f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDzl741sbU4cR-O6-i35vazA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_2467398d-03dd-4492-88ab-022ed0cf0a1a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Morty's Cafe Syracuse",
      "poi_type": "Restaurants",
      "poi_address": "1863 W 700 S Ste 3, Syracuse, UT 84075, USA",
      "poi_short_description": "Fast-casual diner with a wide menu, known for its burgers and fries, plus sandwiches.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, fries, and scone fries. They also highlight the fast service, friendly staff, and fun atmosphere.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019eb303-6352-713d-86fa-d94aaa528877.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019eb303-6352-713d-86fa-d94aaa528877",
        "storage_key": "property/6767906449166425/019eb303-6352-713d-86fa-d94aaa528877.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mortyscafe.com/syracuse",
      "poi_directions_map_url": "https://maps.google.com/?cid=95768751365753732&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mortys-cafe-syracuse",
      "poi_latitude": "41.1031294",
      "poi_longitude": "-112.0620392",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-820-5521",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b822-70e4-8bb1-84aa613b1a8f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b822-70e4-8bb1-84aa613b1a8f",
        "storage_key": "property/6767906449166425/019d02c7-b822-70e4-8bb1-84aa613b1a8f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJczXj_KIbU4cRhAu9BSw9VAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_003ee166-2e36-45ff-b225-30c79bb80717",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Bluff Ridge Elementary School",
      "poi_type": "Education",
      "poi_address": "2680 S 775 W, Syracuse, UT 84075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://bluffridge.davis.k12.ut.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4600597003467809595&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bluff-ridge-elementary-school",
      "poi_latitude": "41.0755391",
      "poi_longitude": "-112.0412491",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-402-2850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b821-73b8-885c-a14797828599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b821-73b8-885c-a14797828599",
        "storage_key": "property/6767906449166425/019d02c7-b821-73b8-885c-a14797828599.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR0An7U4DU4cRO-Nsgpma2D8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e44c31df-f1f6-4bd1-a08e-4cafd3304305",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Legacy Jr. High School",
      "poi_type": "Education",
      "poi_address": "411 N 3200 W, Layton, UT 84041, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://legacyjr.davis.k12.ut.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14701451424181215335&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "legacy-jr-high-school",
      "poi_latitude": "41.0662321",
      "poi_longitude": "-112.027634",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-402-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b821-73b8-885c-a14797828599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b821-73b8-885c-a14797828599",
        "storage_key": "property/6767906449166425/019d02c7-b821-73b8-885c-a14797828599.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAeb8hCYDU4cRZ2D7vC0MBsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_161222cc-5d61-42ba-aea7-231ff1a4d692",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Syracuse High School",
      "poi_type": "Education",
      "poi_address": "665 S 2000 W, Syracuse, UT 84075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f0217-a4f4-73bb-8ec2-7a6237a8255a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0217-a4f4-73bb-8ec2-7a6237a8255a",
        "storage_key": "property/6767906449166425/019f0217-a4f4-73bb-8ec2-7a6237a8255a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.davis.k12.ut.us/716",
      "poi_directions_map_url": "https://maps.google.com/?cid=2060633147643521538&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "syracuse-high-school",
      "poi_latitude": "41.1054926",
      "poi_longitude": "-112.062875",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-402-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b821-73b8-885c-a14797828599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b821-73b8-885c-a14797828599",
        "storage_key": "property/6767906449166425/019d02c7-b821-73b8-885c-a14797828599.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJebbTpDgbU4cRAuqvGe7WmBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_1c4811fa-ed37-45d0-bcc1-f6a89c14c560",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Syracuse Northwest Library",
      "poi_type": "Education",
      "poi_address": "1875 S 2000 W, Syracuse, UT 84075, USA",
      "poi_short_description": "Library featuring books and computers for research, plus a kids' area with scavenger hunts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f0217-a458-703a-8fc4-c58435661277.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0217-a458-703a-8fc4-c58435661277",
        "storage_key": "property/6767906449166425/019f0217-a458-703a-8fc4-c58435661277.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.daviscountyutah.gov/library/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8291890041610561647&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "syracuse-northwest-library",
      "poi_latitude": "41.0866953",
      "poi_longitude": "-112.0643048",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-451-1850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b821-73b8-885c-a14797828599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b821-73b8-885c-a14797828599",
        "storage_key": "property/6767906449166425/019d02c7-b821-73b8-885c-a14797828599.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD5gY21gbU4cRb-jLfg-2EnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_37f9215b-1d67-4a3b-84f6-5d26e227db76",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Antelope Island State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4528 West 1700 South, Syracuse, UT 84075, USA",
      "poi_short_description": "Island park with trails for hiking & horseback riding, plus a historic home & free-roaming bison.",
      "poi_long_description": "Visitors say this state park offers stunning views of the Great Salt Lake and abundant wildlife, including numerous bison, antelope, and various birds. They also highlight the well-maintained hiking and biking trails, as well as the historic Fielding Garr Ranch. Guests mention the park is worth the entrance fee for its unique natural beauty and peaceful atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f0217-a37a-7769-8c58-e6f0bcfd1e11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0217-a37a-7769-8c58-e6f0bcfd1e11",
        "storage_key": "property/6767906449166425/019f0217-a37a-7769-8c58-e6f0bcfd1e11.webp",
        "width": 736,
        "height": 552
      },
      "poi_business_url": "https://stateparks.utah.gov/parks/antelope-island/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5075994780436008203&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "antelope-island-state-park",
      "poi_latitude": "41.0324017",
      "poi_longitude": "-112.2279167",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-773-2941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc55-7783-ac73-ef9672282c46.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc55-7783-ac73-ef9672282c46",
        "storage_key": "property/6767906449166425/019d02c7-bc55-7783-ac73-ef9672282c46.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6bQ5YpQbU4cRCw2g6VuOcUY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_6b882c51-4248-453b-b62c-b2473293e67f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Roy Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "4155 Sandridge Dr, Roy, UT 84067, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f0217-a495-7205-913d-b5f0b9e3ce47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0217-a495-7205-913d-b5f0b9e3ce47",
        "storage_key": "property/6767906449166425/019f0217-a495-7205-913d-b5f0b9e3ce47.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9325502613718243112&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "roy-station",
      "poi_latitude": "41.188757",
      "poi_longitude": "-112.039378",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bf9a-708c-bfdf-9c54c416f616.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bf9a-708c-bfdf-9c54c416f616",
        "storage_key": "property/6767906449166425/019d02c7-bf9a-708c-bfdf-9c54c416f616.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJKRDbXNwPU4cRKBen8jfXaoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_c1722e13-0f36-40ff-bbf4-e10e96376cfc",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "UTA Route 645 - Syracuse/Clearfield",
      "poi_type": "Transportation & Transit",
      "poi_address": "1700 S & 2000 W, Syracuse, UT 84075",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "15",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4016646c-4100-4746-8ded-6c387de46b16",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "UTA Route 626 - Roy/Syracuse",
      "poi_type": "Transportation & Transit",
      "poi_address": "1700 S & 3000 W, Syracuse, UT 84075",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "25",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0a6453bb-461e-4bbf-b081-9791c8793b60",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Salt Lake City International Airport (SLC)",
      "poi_type": "Transportation & Transit",
      "poi_address": "3920 W Terminal Dr, Salt Lake City, UT 84122",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "28",
      "poi_walking_minutes": "420",
      "poi_biking_minutes": "150 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d362c83c-d41f-4e7f-9960-be2c2f7b4e3a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Lifetime Products",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Freeport Center, Clearfield, UT 84016, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f0217-a42d-7546-ba59-29d572f85f69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0217-a42d-7546-ba59-29d572f85f69",
        "storage_key": "property/6767906449166425/019f0217-a42d-7546-ba59-29d572f85f69.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "https://www.lifetime.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11989089617266461519&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lifetime-products",
      "poi_latitude": "41.0968749",
      "poi_longitude": "-112.0266681",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-776-1532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-bc19-7337-8951-15907c738e3a",
        "storage_key": "property/6767906449166425/019d02c7-bc19-7337-8951-15907c738e3a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-XXjer0EU4cRT8t9aXzNYaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_382ee233-3eac-410c-8ec9-2d195da0c760",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Imagination Time: Childcare and Preschool",
      "poi_type": "Education",
      "poi_address": "1125 W 2150 S, Syracuse, UT 84075, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f066b-1b76-71bd-adf4-c56ff40f544c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f066b-1b76-71bd-adf4-c56ff40f544c",
        "storage_key": "property/6767906449166425/019f066b-1b76-71bd-adf4-c56ff40f544c.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://imaginationtimechildcare.com/syracuse-location/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15767170463051359064&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "imagination-time-childcare-and-preschool",
      "poi_latitude": "41.0823449",
      "poi_longitude": "-112.0481529",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 801-628-6185",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b821-73b8-885c-a14797828599.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b821-73b8-885c-a14797828599",
        "storage_key": "property/6767906449166425/019d02c7-b821-73b8-885c-a14797828599.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk3L-q6wcU4cRWCM1g_890No",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_f8b8f0fa-6975-4243-a079-6ddde6099e53",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2228 W 1700 S, Syracuse, UT 84075, USA",
      "poi_short_description": "Department store offering furniture and a wide range of merchandise, including groceries and apparel.",
      "poi_long_description": "Customers consistently praise this store for its wide selection of items, great value, and friendly staff.\n\nOther reviews mention service can be inefficient and the store can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019f066c-d912-76ba-8b77-dcbe40deef2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f066c-d912-76ba-8b77-dcbe40deef2f",
        "storage_key": "property/6767906449166425/019f066c-d912-76ba-8b77-dcbe40deef2f.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3848-syracuse-ut/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=4305469618235588479&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "41.0902564",
      "poi_longitude": "-112.0696205",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 801-775-9688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-b835-72ab-a221-bf96f97585fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02c7-b835-72ab-a221-bf96f97585fa",
        "storage_key": "property/6767906449166425/019d02c7-b835-72ab-a221-bf96f97585fa.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJM-8FzF0bU4cRfz8rcs4ZwDs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    }
  ],
  "office_hours": [
    {
      "id": "ec_5f1044f124442312f268aefc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2088a87b5f319bed8afbc620",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ef484ebbd178f6d1cec89d1c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ca58fd4c6f062b869fe496c4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_e8a68ca1b84b0120bf9be5f1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_618eda25cc33735220edd1c6",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_23395217-4444-4d8a-b529-71dbee586ca1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "rating": "5.0",
      "name": "Dylan Gilmore",
      "text": "Aria Townhomes and Apartments is an amazing place to live! My wife and I moved in March 2024 and we left May 2025. Jace the Assistant manager there is amazing! He is willing to help when he can to make living there a pleasant experience. He is kind, patient and always willing to help. He really strives to give his tenants their best experience he can. The girls that are upfront and answer me the phones are always so kind and helpful as well. There will always be a sweet place in my heart for these apartments lots of good and life memories here! Thank you again to all the staff and maintenance workers at this place!",
      "date": "2025-06-03",
      "title": ""
    },
    {
      "id": "custom_b43a6d7b-8c06-461c-bccc-287461b7296c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "rating": "5.0",
      "name": "Kalley Jaques",
      "text": "Aria and the management team has been nothing but stellar! At my previous rental i had been there for 10 years and there were noisy neighbors and the grounds were trashed. Aria has been a total upgrade in every way from where we used to be.\nI rented out the clubhouse for a baby shower, and Jace and Kylee were amazing to work with. The communication from the team is clear and concise. They have great amenities, and the apartments are lovely and spacious and clean. I think my favorite feature of being in the community is the valet trash service and the friendliness of my neighbors, the community activities are also a lot of fun!\nKami and the other leasing agents are total rockstars!! They are wonderful to talk to and answer your questions in a timely and accurate manner. They are so fun to talk with!\nAlso, Falcon, the maintenance guy....he is so responsive and friendly!! He is so good at what he does and gives the best customer service.\nEveryone has been such a pleasure to interact with!! They truly want you to feel like this is your home and community.",
      "date": "2025-07-29",
      "title": ""
    },
    {
      "id": "custom_750bee0d-df53-4359-b3c9-84ac69f1b16e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "rating": "5.0",
      "name": "Keegan and Katie Goetz",
      "text": "We lived in an apartment at Aria for 2 years before buying a house. Our time at Aria was great. The management team was readily available and answered questions promptly. Service requests were quickly and accurately fulfilled. We found the overall environment of the complex safe and clean. We would definitely recommend Aria as a great apartment complex to live in.",
      "date": "2025-04-02",
      "title": ""
    },
    {
      "id": "custom_b6393070-92ab-4e58-b2c7-d60f7bfd2a16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "rating": "4.0",
      "name": "Jason Weyburn",
      "text": "Wonderful Community but Be Prepared for Extra Fees\n\nWe've had a wonderful experience living in this community! The onsite management and maintenance teams are absolutely fantastic—always responsive and attentive. The community itself is vibrant and welcoming, making it a lovely place to call home.\n\nHowever, it's important to be aware of the additional fees that come with living here, which is a reflection of the management company, AMC, not the onsite staff. Since AMC took over from Greystar, we've seen a noticeable increase in monthly fees. While these charges are not reflective of the onsite staff, they do impact overall living costs.\n\nOverall, the community and onsite staff are wonderful! However potential tenants should budget for the various fees associated with AMC's management practices.\n\nThank you!",
      "date": "2025-07-14",
      "title": ""
    },
    {
      "id": "custom_3a40188f-2c9d-442b-9cc9-12144fe50cfc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "rating": "5.0",
      "name": "Erik Maki",
      "text": "This is a great community. Kylee, the manager is doing great the residents. She communicates with vendors and her team to be the property in shape. I visit and work with a lot of properties and this one is in my top 5.  The amenities are great and the clubhouse is huge!",
      "date": "2025-06-15",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_b1a34c84-c823-4d88-ade1-e2c1df07bfa0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "1 Bedroom, 1 Bathroom, 905 sq.ft.",
      "virtual_tour_type": "",
      "virtual_tour_url": "https://my.matterport.com/show/?m=1fcdCWMPr3c"
    },
    {
      "id": "custom_acab728c-945a-4fe4-96b2-31fb7799ab3b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "2 Bedroom, 2 Bathroom, 1156 sq.ft.",
      "virtual_tour_type": "",
      "virtual_tour_url": "https://my.matterport.com/show/?m=wPxk5uN9hxy"
    },
    {
      "id": "custom_0ccc4575-cd82-4ae1-a26c-3f58f81f3288",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "2 Bedroom, 2 Bathroom, 1157 sq.ft.",
      "virtual_tour_type": "",
      "virtual_tour_url": "https://my.matterport.com/show/?m=WEezJ5wzket"
    },
    {
      "id": "custom_df259f50-b46a-49d1-967c-3500a398a03f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "3 Bedroom, 2 Bathroom, 1,429 sq.ft.",
      "virtual_tour_type": "",
      "virtual_tour_url": "https://my.matterport.com/show/?m=QTJo3Npa4ar"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199dfaa-cc84-745c-9189-8d376ce027de",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-aria-auto",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "generator",
      "page_item_url": "aria-apartments-stainless-steel-syracuse",
      "search_query": "apartments with stainless steel appliances in Syracuse UT",
      "category": "Amenity",
      "h1_title": "Apartments with Stainless Steel in Syracuse",
      "h2_subtitle": "Discover Aria in Syracuse, UT, where each apartment features stylish stainless steel appliances. Upgrade your lifestyle with our modern amenities and spacious layouts.",
      "page_copy": "Welcome to Aria in Syracuse, UT, where modern living meets convenience. Our apartments with stainless steel appliances provide a sleek and contemporary look, enhancing both style and functionality. Nestled in a vibrant community, Aria offers a selection of one, two, and three-bedroom floor plans, ensuring ample space and comfort for every resident. \n\nBeyond the chic kitchens, residents will enjoy amenities like a refreshing year-round pool, a state-of-the-art fitness center, and a pickleball court. Each apartment boasts elegant features such as quartz countertops, large closets, and LVT flooring. Experience the ultimate combination of contemporary design and convenience at Aria. Schedule a tour today to see firsthand how our stainless steel appliances can elevate your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and outdoor lighting.",
        "public_id": "019d02c7-4a47-76d1-9b3a-710b0e4d7281",
        "storage_key": "property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Stainless Steel in Syracuse",
      "seo_description": "Explore Aria apartments in Syracuse, UT, with sleek stainless steel appliances and modern amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "generator",
      "page_item_url": "aria-quartz-countertop-apartments-davis-county",
      "search_query": "quartz countertop apartments Davis County",
      "category": "Amenity",
      "h1_title": "Quartz Countertop Apartments in Davis County",
      "h2_subtitle": "Discover premium living at Aria in Davis County with quartz countertop apartments. Experience exceptional style and comfort in every unit.",
      "page_copy": "Aria in Syracuse, Davis County, offers luxurious living with apartments featuring elegant quartz countertops. These beautifully designed kitchens elevate the aesthetic and functionality of your home. Choose from various one, two, and three-bedroom floor plans that provide a spacious and welcoming atmosphere, perfect for any lifestyle.\n\nBeyond the stunning interiors, Aria offers a range of amenities to complement your modern lifestyle, including a year-round swimming pool, a modern fitness facility, and a fun-filled pickleball court. Each apartment is equipped with large closets, LVT flooring, and stainless steel appliances, enhancing both comfort and convenience. Discover Aria today and see how our quartz countertops and premium amenities make everyday living extraordinary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and outdoor lighting.",
        "public_id": "019d02c7-4a47-76d1-9b3a-710b0e4d7281",
        "storage_key": "property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Quartz Countertop Apts in Davis County",
      "seo_description": "Explore Aria in Davis County, offering quartz countertop apartments with luxurious amenities. Experience premier living today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "generator",
      "page_item_url": "aria-year-round-pool-apartments-syracuse",
      "search_query": "all year round pool apartments Syracuse UT",
      "category": "Amenity",
      "h1_title": "All Year Round Pool Apartments in Syracuse",
      "h2_subtitle": "Experience luxury living at Aria, where our Syracuse apartments come with an all year round pool and modern amenities.",
      "page_copy": "Discover Aria in Syracuse, UT, the perfect destination for those seeking apartments with an all year round pool. Dive into comfort and relaxation, no matter the season, with our heated pool as the centerpiece of our luxurious community. At Aria, you'll find thoughtfully designed one, two, and three-bedroom layouts that cater to every need.\n\nApart from the inviting pool, Aria offers a host of other outstanding amenities, including a cutting-edge fitness center and a lively pickleball court. Inside each apartment, enjoy modern features such as quartz countertops, stainless steel appliances, and large closets. Experience a vibrant lifestyle coupled with the convenience and luxury of Aria's amenities. Visit today and see why Aria is the perfect choice for pool lovers in Syracuse, UT.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and outdoor lighting.",
        "public_id": "019d02c7-4a47-76d1-9b3a-710b0e4d7281",
        "storage_key": "property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "All Year Round Pool Apartments Syracuse UT",
      "seo_description": "Discover Aria in Syracuse, UT, offering all year round pool apartments with luxurious amenities. Dive into comfort and convenience today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "generator",
      "page_item_url": "aria-pickleball-court-apartments-84075",
      "search_query": "pickleball court apartments 84075",
      "category": "Amenity",
      "h1_title": "Pickleball Court Apartments in 84075",
      "h2_subtitle": "Join the community at Aria in zip code 84075, offering apartments with a pickleball court. Experience active living in a vibrant environment.",
      "page_copy": "Welcome to Aria, located in the heart of Syracuse, UT, in the 84075 area, where active living is made easy with our on-site pickleball court. Residents can enjoy engaging with neighbors and staying fit with one of the fastest-growing sports right at home. Choose from our selection of spacious one, two, and three-bedroom floor plans that fit your lifestyle.\n\nIn addition to the exciting pickleball court, Aria offers exceptional amenities like a year-round pool and a modern fitness center. Each apartment is thoughtfully designed, featuring quartz countertops, stainless steel appliances, LVT flooring, and large closets. Embrace a community-focused lifestyle with the convenience of luxurious features and amenities at Aria. Visit us and see how you can elevate your living experience today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and outdoor lighting.",
        "public_id": "019d02c7-4a47-76d1-9b3a-710b0e4d7281",
        "storage_key": "property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pickleball Court Apartments in 84075",
      "seo_description": "Discover Aria in the 84075 area, featuring apartments with a pickleball court. Join our vibrant community and enjoy top-notch amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "generator",
      "page_item_url": "aria-fitness-center-apartments-davis-county",
      "search_query": "fitness center apartments in Davis County",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Davis County",
      "h2_subtitle": "Discover Aria in Davis County, offering apartments with a modern fitness center. Enjoy staying fit with state-of-the-art facilities.",
      "page_copy": "At Aria, located in Syracuse within Davis County, residents enjoy not only stylish living spaces but also access to a top-tier modern fitness center. Our gym is equipped with the latest amenities to help you achieve your fitness goals without leaving the comfort of your home. With options ranging from one to three-bedroom floor plans, our apartments cater to varied lifestyle needs.\n\nComplementing the fitness center, Aria offers a wealth of luxurious amenities including a year-round swimming pool and a fun pickleball court. Each apartment boasts beautiful features like quartz countertops, stainless steel appliances, and large closets. Whether you're focusing on fitness or relaxation, Aria in Davis County provides a perfect balance of both. Experience elevated living with us today by scheduling a tour of our community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and outdoor lighting.",
        "public_id": "019d02c7-4a47-76d1-9b3a-710b0e4d7281",
        "storage_key": "property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Davis County",
      "seo_description": "Explore Aria in Davis County featuring apartments with a modern fitness center. Achieve your fitness goals with style and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "generator",
      "page_item_url": "aria-1-bedroom-apartments-syracuse-ut",
      "search_query": "1 bedroom apartments syracuse ut",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Syracuse, UT",
      "h2_subtitle": "Explore stylish 1 bedroom apartments at Aria in Syracuse, UT. Experience comfortable living with modern amenities and spacious design.",
      "page_copy": "Welcome to Aria, where our 1 bedroom apartments in Syracuse, UT, offer comfortable and modern living. Perfect for singles or couples, these thoughtfully designed spaces maximize comfort with spacious layouts and contemporary finishes. Each apartment is equipped with LVT flooring, large closets, and stainless steel appliances, ensuring a blend of style and functionality.\n\nBeyond your front door, indulge in a variety of community amenities including a year-round pool, a dynamic pickleball court, and a cutting-edge fitness center. Located in the heart of Davis County, Aria provides easy access to local dining, shopping, and entertainment, making it a perfect choice for those seeking both convenience and luxury. Discover your new Syracuse home today with a tour of our exquisite community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and outdoor lighting.",
        "public_id": "019d02c7-4a47-76d1-9b3a-710b0e4d7281",
        "storage_key": "property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Syracuse, UT",
      "seo_description": "Find your ideal 1 bedroom apartment at Aria in Syracuse, UT. Enjoy modern living with fantastic amenities and spacious design.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "generator",
      "page_item_url": "aria-2-bedroom-floorplans-near-davis-county",
      "search_query": "2 bedroom floorplans near davis county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Floorplans Near Davis County",
      "h2_subtitle": "Discover versatile 2 bedroom floorplans at Aria, situated near Davis County. Enjoy spacious living with premium amenities.",
      "page_copy": "At Aria, located conveniently near Davis County, explore our diverse 2 bedroom floorplans that cater to your lifestyle needs. Each apartment is designed with spacious layouts and high-end finishes, including quartz countertops and stainless steel appliances, providing a comfortable, modern living experience.\n\nThe community at Aria offers more than just beautiful interiors. Take advantage of our comprehensive amenities like a year-round pool, pickleball court, and state-of-the-art fitness center, enhancing your living experience. With our ideal location near Davis County, you’ll have quick access to local attractions and conveniences, making Aria the perfect place to call home. Tour our community today and see firsthand what makes our 2 bedroom floorplans stand out.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and outdoor lighting.",
        "public_id": "019d02c7-4a47-76d1-9b3a-710b0e4d7281",
        "storage_key": "property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Floorplans Near Davis County",
      "seo_description": "Discover Aria's 2 bedroom floorplans near Davis County with spacious designs and premium amenities. Experience modern living at its best.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "generator",
      "page_item_url": "aria-3-bedroom-rentals-84075",
      "search_query": "3 bedroom rentals 84075",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Rentals in 84075",
      "h2_subtitle": "Find exquisite 3 bedroom rentals at Aria, located in the 84075 area. Enjoy spacious interiors and upscale community features.",
      "page_copy": "Discover the perfect blend of luxury and comfort with Aria's 3 bedroom rentals in the 84075 area. Our expansive floor plans are designed with modern lifestyles in mind, featuring premium finishes like quartz countertops, LVT flooring, and stainless steel appliances. Spacious interiors ensure everyone has room to thrive and enjoy.\n\nBeyond the apartment doors, residents can relish in resort-style amenities such as our shimmering year-round pool and engaging pickleball court. Keep up with fitness goals at our well-equipped modern fitness center. Located in Syracuse and tirelessly designed for convenience, our community offers easy access to local attractions in Davis County, making Aria not just a place to live, but a place to thrive. Tour our community today to find your ideal home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and outdoor lighting.",
        "public_id": "019d02c7-4a47-76d1-9b3a-710b0e4d7281",
        "storage_key": "property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Rentals in 84075",
      "seo_description": "Explore 3 bedroom rentals at Aria in the 84075 area. Enjoy spacious living with luxury features and prime community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "generator",
      "page_item_url": "aria-apartments-near-weber-state-university-davis-utah",
      "search_query": "apartments near weber state university davis utah",
      "category": "School",
      "h1_title": "Apartments Near Weber State University Davis",
      "h2_subtitle": "Discover ideal living at Aria, located near Weber State University in Davis, Utah. Enjoy modern convenience and top-tier amenities.",
      "page_copy": "Located conveniently near Weber State University in Davis, Utah, Aria offers a premier living experience for students, faculty, and professionals alike. Our selection of one, two, and three-bedroom apartments provides flexible options to suit diverse lifestyles. Each apartment comes equipped with stylish finishes such as LVT flooring and stainless steel appliances, ensuring a contemporary feel.\n\nAria boasts a range of community amenities designed to enhance your lifestyle, including a year-round pool and a well-equipped fitness center. For those who enjoy sports, our pickleball court provides a great way to stay active. Located in a vibrant part of Syracuse, our community ensures easy access to educational opportunities, dining, and entertainment, making it a perfect choice for those connected with Weber State University. Explore our community today to experience all that Aria has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and outdoor lighting.",
        "public_id": "019d02c7-4a47-76d1-9b3a-710b0e4d7281",
        "storage_key": "property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Weber State University Davis",
      "seo_description": "Find your home at Aria, with modern apartments near Weber State University Davis, Utah, designed for convenience and style.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "generator",
      "page_item_url": "aria-apartments-near-intermountain-health-layton-hospital",
      "search_query": "apartments near Intermountain Health Layton Hospital Syracuse",
      "category": "Hospital",
      "h1_title": "Apartments Near Intermountain Health Layton",
      "h2_subtitle": "Explore Aria's apartments near Intermountain Health Layton Hospital in Syracuse. Enjoy modern comforts and a vibrant community.",
      "page_copy": "Aria offers the perfect residential choice for those seeking apartments near Intermountain Health Layton Hospital in Syracuse. Our community provides easy access to healthcare facilities while offering a range of one, two, and three-bedroom floor plans designed with comfort in mind. Each apartment is equipped with air conditioning, large closets, and sleek stainless steel appliances to cater to modern living needs.\n\nBeyond your apartment, our community offers top-notch amenities including a swimming pool available year-round and a modern fitness center, making it easy for residents to maintain an active lifestyle. Positioned conveniently in Syracuse, Aria not only offers proximity to nearby medical facilities like Intermountain Health Layton Hospital but also ensures that you have quick access to local attractions and conveniences, enhancing your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and outdoor lighting.",
        "public_id": "019d02c7-4a47-76d1-9b3a-710b0e4d7281",
        "storage_key": "property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Intermountain Health Layton",
      "seo_description": "Discover Aria's modern apartments near Intermountain Health Layton Hospital in Syracuse. Enjoy convenience and premier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "generator",
      "page_item_url": "aria-apartments-close-to-ogden-clinic-kaysville",
      "search_query": "apartments close to Ogden Clinic Kaysville Davis County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Ogden Clinic Kaysville",
      "h2_subtitle": "Experience the charm of Aria, offering apartments close to Ogden Clinic in Kaysville, Davis County. Enjoy spacious living and upscale amenities.",
      "page_copy": "Aria is an excellent choice for those seeking apartments close to Ogden Clinic in Kaysville, situated in Davis County. Our community offers a variety of one, two, and three-bedroom layouts, each thoughtfully designed with modern conveniences including in-unit washer/dryer, LVT flooring, and air conditioning for your comfort.\n\nResidents at Aria can take advantage of our outstanding community features such as a year-round swimming pool and a state-of-the-art fitness center, perfect for staying active and relaxed. Nestled in the vibrant city of Syracuse, living at Aria means you'll have easy access to important services like the Ogden Clinic as well as other local attractions, making daily life convenient and enjoyable. Schedule a visit today to see how our community can meet your needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and outdoor lighting.",
        "public_id": "019d02c7-4a47-76d1-9b3a-710b0e4d7281",
        "storage_key": "property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Ogden Clinic Kaysville",
      "seo_description": "Find ideal living at Aria, with apartments close to Ogden Clinic in Kaysville, Davis County. Enjoy convenience and superb amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "generator",
      "page_item_url": "aria-apartments-near-ellison-park-syracuse",
      "search_query": "apartments near Ellison Park Syracuse",
      "category": "Park",
      "h1_title": "Apartments Near Ellison Park in Syracuse",
      "h2_subtitle": "Find your perfect home at Aria, situated near the serene Ellison Park in Syracuse. Enjoy contemporary living and lush surroundings.",
      "page_copy": "Aria is a premier residential community offering apartments near Ellison Park in Syracuse, ideal for those who appreciate both convenience and nature. Our one, two, and three-bedroom apartments feature high-end finishes including quartz countertops and stainless steel appliances, providing a comfortable and stylish living environment.\n\nResidents of Aria benefit from a range of amenities such as a sparkling year-round pool, a modern fitness center, and a pickleball court, all designed to promote an active lifestyle. Located just minutes from Ellison Park, Aria combines natural beauty with urban convenience, making it an excellent place to call home. Experience the charm of Syracuse living with easy access to the park's recreational opportunities and the vibrant community right outside your door.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and outdoor lighting.",
        "public_id": "019d02c7-4a47-76d1-9b3a-710b0e4d7281",
        "storage_key": "property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ellison Park in Syracuse",
      "seo_description": "Discover Aria's modern apartments near Ellison Park, Syracuse. Enjoy lush surroundings and exceptional amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "generator",
      "page_item_url": "aria-living-close-to-great-salt-lake-shorelands-preserve",
      "search_query": "living close to Great Salt Lake Shorelands Preserve UT",
      "category": "Park",
      "h1_title": "Living Close to Great Salt Lake Shorelands",
      "h2_subtitle": "Discover tranquil living close to the Great Salt Lake Shorelands Preserve at Aria in Syracuse, UT. Enjoy a peaceful, vibrant lifestyle.",
      "page_copy": "At Aria, experience the serenity of living close to the Great Salt Lake Shorelands Preserve in Syracuse, UT. Our community offers a selection of spacious one, two, and three-bedroom apartments designed with luxury and functionality in mind, featuring modern amenities like quartz countertops, LVT flooring, and in-unit washers and dryers.\n\nResidents relish the vibrant lifestyle that Aria's amenities support, including a year-round swimming pool and a cutting-edge fitness center. With the Great Salt Lake Shorelands Preserve nearby, enjoy easy access to breathtaking natural beauty and diverse wildlife. Aria not only provides modern living spaces but also connects you to the great outdoors and the comforts of home, making it a perfect choice for nature lovers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and outdoor lighting.",
        "public_id": "019d02c7-4a47-76d1-9b3a-710b0e4d7281",
        "storage_key": "property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to Great Salt Lake Shorelands",
      "seo_description": "Enjoy peaceful living close to the Great Salt Lake Shorelands Preserve at Aria, Syracuse, UT. Discover modern comforts and natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "generator",
      "page_item_url": "aria-apartment-homes-near-layton-commons-park",
      "search_query": "apartment homes near Layton Commons Park Davis County",
      "category": "Park",
      "h1_title": "Apartment Homes Near Layton Commons Park",
      "h2_subtitle": "Explore Aria's apartment homes near Layton Commons Park in Davis County. Enjoy modern amenities and convenience.",
      "page_copy": "Aria offers stunning apartment homes near Layton Commons Park, located in the heart of Davis County. Our community features an array of beautifully appointed one, two, and three-bedroom apartments. Designed with attention to detail, these homes provide stainless steel appliances, large closets, and air conditioning, ensuring a comfortable and stylish living experience.\n\nLiving at Aria means you'll enjoy exclusive amenities, like our year-round swimming pool and state-of-the-art fitness center, adding convenience to your lifestyle. Proximity to Layton Commons Park allows residents easy access to leisurely strolls and community events in a natural setting. Embrace the perfect blend of urban accessibility and outdoor recreation right from your home at Aria.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and outdoor lighting.",
        "public_id": "019d02c7-4a47-76d1-9b3a-710b0e4d7281",
        "storage_key": "property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes Near Layton Commons Park",
      "seo_description": "Discover Aria's apartment homes near Layton Commons Park, Davis County. Enjoy modern living with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "generator",
      "page_item_url": "aria-syracuse-rentals-by-barnes-park",
      "search_query": "Syracuse rentals by Barnes Park",
      "category": "Park",
      "h1_title": "Syracuse Rentals by Barnes Park",
      "h2_subtitle": "Discover Aria's Syracuse rentals located conveniently by Barnes Park. Enjoy premier amenities and a welcoming community.",
      "page_copy": "Nestled in the vibrant city of Syracuse, Aria offers exceptional rentals conveniently located by Barnes Park. Our thoughtfully designed one, two, and three-bedroom floor plans boast modern touches such as quartz countertops and stainless steel appliances, providing a perfect blend of comfort and style.\n\nResidents of Aria enjoy a variety of on-site amenities, including a year-round pool, fitness center, and pickleball court, encouraging a healthy and active lifestyle. The nearby Barnes Park offers abundant opportunities for outdoor fun with its playgrounds and green spaces. Aria provides a harmonious balance of suburban tranquility and urban convenience, making it an ideal rental choice in Syracuse.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and outdoor lighting.",
        "public_id": "019d02c7-4a47-76d1-9b3a-710b0e4d7281",
        "storage_key": "property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Syracuse Rentals by Barnes Park",
      "seo_description": "Explore Syracuse rentals by Barnes Park at Aria. Enjoy modern amenities and a vibrant community life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166425",
      "source": "generator",
      "page_item_url": "aria-apartments-near-jensen-nature-park-syracuse",
      "search_query": "apartments near Jensen Nature Park 84075",
      "category": "Park",
      "h1_title": "Apartments Near Jensen Nature Park 84075",
      "h2_subtitle": "Find your dream home at Aria, with apartments near Jensen Nature Park in Syracuse. Enjoy a seamless blend of nature and luxury.",
      "page_copy": "Aria offers beautifully crafted apartments near Jensen Nature Park in the 84075 area, providing residents with a unique living experience. Choose from our selection of one, two, and three-bedroom floor plans, each featuring high-end finishes like stainless steel appliances and LVT flooring, designed to enhance both comfort and style.\n\nLocated in Syracuse, these apartments provide easy access to the serene Jensen Nature Park, perfect for nature enthusiasts. Complementing the natural surroundings, Aria's amenities include a modern fitness center and a year-round swimming pool, fostering an active yet relaxed lifestyle. Aria's location not only connects you to the beauty of outdoor landscapes but also ensures that luxury meets leisure right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and outdoor lighting.",
        "public_id": "019d02c7-4a47-76d1-9b3a-710b0e4d7281",
        "storage_key": "property/6767906449166425/019d02c7-4a47-76d1-9b3a-710b0e4d7281.webp",
        "width": 800,
        "height": 600
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Jensen Nature Park 84075",
      "seo_description": "Discover Aria's apartments near Jensen Nature Park in Syracuse, 84075. Enjoy luxury living with modern amenities in a natural setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5295"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425049"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=c2584654991e7d93d89de81b50ddc6cae8a0627cc142503ea7f83a3c5da41445d7d6a8f3d4975c22eca077bf0ea477cc\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W78JLFLP"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "658ARI"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "8618002786"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "11066609-DB00"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Aria Apartments/scheduletourwidget/Z37Q3yABP4rKkbX3qH/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Ik1BMzF6TDNhVFZ1d2ZnTFFhUnFxUEE9PSIsInZhbHVlIjoiRU9uNUt6RUlyU2tDUzJpUTVZN2ErUT09IiwibWFjIjoiNjhhMmQzNGJiYzIzMThmYWI5YjRhN2IyYjdhOWI5ZjRmMTI5ZmNmY2IwMmRmYTZkY2RmMTU5MTE1ZDFmOWNiNyJ9"
    }
  ],
  "custom_qb_id": "5295",
  "custom_repli_id": "18104425049",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=c2584654991e7d93d89de81b50ddc6cae8a0627cc142503ea7f83a3c5da41445d7d6a8f3d4975c22eca077bf0ea477cc\"></script>",
  "custom_google_gtm_id": "GTM-W78JLFLP",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "658ARI",
  "custom_hubspot_company_id": "8618002786",
  "custom_broker_license_number": "11066609-DB00",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Aria Apartments/scheduletourwidget/Z37Q3yABP4rKkbX3qH/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Ik1BMzF6TDNhVFZ1d2ZnTFFhUnFxUEE9PSIsInZhbHVlIjoiRU9uNUt6RUlyU2tDUzJpUTVZN2ErUT09IiwibWFjIjoiNjhhMmQzNGJiYzIzMThmYWI5YjRhN2IyYjdhOWI5ZjRmMTI5ZmNmY2IwMmRmYTZkY2RmMTU5MTE1ZDFmOWNiNyJ9",
  "custom_audioeye_site_id": "e96c758f-aede-4e8f-812b-f86f518537cc",
  "custom_audioeye_site_hash": "caaa0a24440ba0cbe5f4b578816b7716"
};

export const generatedAt = '2026-08-24T16:58:41.368Z';
